{
  "translations": {
    "accessbility.clickSelect": "Click to select rating",
    "accessbility.continueButton": "Continue",
    "accessbility.continueSurvey": "Continue survey",
    "accessbility.goNext": "Click to go to next question",
    "accessbility.means": "means",
    "accessbility.skipQuestion": "Click to skip this question",
    "accessibility.skipToContent": "Skip to Content",
    "admin.question.nps": "eNPS",
    "anon.convo.click.here": "Enter your code here",
    "anon.convo.enter.code.here": "Enter your code here",
    "anonymity-dialog.content.anonymized.one": "This survey is administered by WorkTango, a secure third-party provider. Results may be reported using attribute information that is tracked with your survey response. This information is collected via questions asked in the survey and/or via data provided by your organization (e.g., Role, Location, Department, Tenure). ",
    "anonymity-dialog.content.anonymized.two": "In order to protect your confidentiality, results will only be reported where there are {{threshold}} or more submitted responses within any attribute group (or combinations of attribute groups)",
    "anonymity-dialog.content.not-anonymized.one": "This survey is not anonymized.",
    "anonymity-dialog.content.not-anonymized.three": "Thank you for your participation.",
    "anonymity-dialog.content.not-anonymized.two": "Your individual responses will be identifiable and may be attributed to you. Your honest feedback is essential for us to improve, and we appreciate your willingness to share your thoughts openly.",
    "anonymity-dialog.title": "How responses will be reported",
    "anonymous.convo.email.reaction.great.idea": "acknowledged your comment and thinks it's a Great Idea!",
    "anonymous.convo.email.reaction.like": "\"liked\" your comment.",
    "anonymous.convo.email.reaction.working.on.it": "has reacted to your comment and would like to let you know that it's being worked on.",
    "button.dismiss": "Dismiss",
    "button.skip": "Skip",
    "comment.placeholder": "Write your comment here",
    "comment.title": "Comments",
    "copyright": "Copyright {{year}} WorkTango Inc. All Rights Reserved.",
    "courier.anon.convo.click.here": "See the conversation",
    "courier.email.anon.convo.employee.have.replied": "an employee has replied to an anonymous conversation that you are a part of. As per WorkTango’s Employee Promise, your response is confidential.",
    "courier.email.privacy.policy": "Privacy Policy",
    "courier.email.support": "Support",
    "courier.email.you.received.email.because": "You have received this email as a WorkTango user.",
    "courier.feedback.details": "As per WorkTango’s Employee Promise, your response is confidential. Click below and enter in your personal code to see more.",
    "courier.general.hard.link": "If the button does not work, paste the following link in your browser:",
    "dismiss": "Dismiss",
    "docTitle.kioskList": "WorkTango - Select a Survey to Continue",
    "docTitle.kioskLogin": "WorkTango Kiosk - Login Screen",
    "docTitle.surveyName": "{{name}} survey",
    "dropdown.ariaLabel": "Select an option for {{question}}",
    "enps.question.greatPlace": "",
    "eric-04-03-new-library-question-q1": "How long have you lived in your current country of residence?",
    "eric-04-03-new-library-question-q2": "Do you require any time away during typical working hours? Select all that apply. \na) To provide caregiving responsibilities\nb) To pray\nc) To meditate\nd) To attend a medical need\ne) To take care of my mental well-being\nf) To work instead when I am most efficient\ng) I do not have to deal with any personal needs during work hours \nh) Other (please specify in comment box) \ni) Prefer not to answer",
    "error.submission": "An error has occurred when submitting your answer:",
    "error.unknow": "An unknown issue has occurred. Please refresh your page and try again",
    "feedback.code": "Personal code:",
    "feedback.details": "Click the link below and enter in your personal code to see more.",
    "feedback.email.subject.anon": "Your completely anonymous feedback has a response.",
    "feedback.has.replied.to.you": "has replied to your survey comment.",
    "feedback.placeholder": "Enter your response",
    "footer.poweredby": "Powered by WorkTango",
    "general.click.here": "Click here",
    "general.greeting": "Hi",
    "general.hard.link": "If the button does not work, paste the following link in your browser:",
    "graph.notEnough.header": "There are no responses yet or not enough based on your confidentiality threshold. Please check back later.",
    "hardcoded - dei - q1": "Do you or have you ever identified as transgender? Transgender is an umbrella term used to describe people whose gender identity or gender expression differs from the biological sex they were assigned at birth.",
    "hardcoded - dei - q2": "I believe this organization will take appropriate action in response to incidents of harassment.",
    "hardcoded - dei - q3": "I believe this organization will take appropriate action in response to incidents of discrimination.",
    "hardcoded - library question 1 - question text": "I feel safe and comfortable when I come to work.",
    "hardcoded - library question 2 - question text": "The environment at this organization supports a balance between work and personal life.",
    "kiosk.enterPlaceholder": "Enter your {{kiosk_id}}",
    "kiosk.footer": "Copyright {{year}} WorkTango Inc. All Rights Reserved",
    "kiosk.login.error": "Invalid kiosk id, please try again",
    "kiosk.selectSurvey": "Please choose a survey to continue:",
    "kiosk.welcome": "View available surveys by entering your {{kiosk_id}}.",
    "logic.cleanup": "Changing your response may require you to re-answer any following questions.",
    "logic.cleanup.warning": "Warning",
    "no.active.surveys.for": "No active surveys found for",
    "or": "or",
    "peopleResponded": "people responded",
    "required": "required",
    "result.avg": "AVG",
    "result.comments": "Comments",
    "result.positive": "Favourable",
    "saved": "Saved",
    "saving": "Saving",
    "screenReader.option": "Option {{option}}",
    "screenReader.peopleSelected": "{{percent}} percentage of people selected this option.",
    "showing.all": "All Respondents",
    "survey.anonymity-text.anonymized": "How responses will be reported",
    "survey.anonymity-text.details-here": "Details here.",
    "survey.anonymity-text.not-anonymized": "This survey is not anonymized.",
    "survey.clickButtonText": "Click here",
    "survey.confirm": "Click below to submit your responses",
    "survey.error.title": "Oops, something went wrong",
    "survey.expired.greeting": "Survey has expired",
    "survey.expired.message": "This survey can't be answered anymore.",
    "survey.kiosk.copyright": "© {{year}} All Rights Reserved",
    "survey.kiosk.login.button": "View Survey(s)",
    "survey.kiosk.poweredby": "Powered by",
    "survey.language.sr-rs": "Srpski",
    "survey.linkNotWorking": "If the above link does not work, copy and paste the following link in your browser:",
    "survey.navigation.next": "Next",
    "survey.navigation.position": "{{questionIndex}} of {{questionCount}}",
    "survey.navigation.previous": "Previous",
    "survey.navigation.progress": "{{questionIndex}} of {{questionCount}} answered",
    "survey.navigation.screen-reader-label": "Question Number {{questionIndex}} of {{questionCount}}",
    "survey.navigation.screen-reader-message": "This is a message",
    "survey.not-applicable.message": "This survey is aimed at a specific group, and it looks like that's not you right now. Nothing further is needed, thanks for taking a moment to check.",
    "survey.not-applicable.title": "No questions here for you this time",
    "survey.not-found.message": "The survey was not found. Please contact the person who provided you with this survey link for more information.",
    "survey.not-found.title": "Sorry, this link is invalid.",
    "survey.open-survey.error-invalid-submission": "There was a problem with your submission. Please refresh the page and try again.",
    "survey.open-survey.error-not-available": "This survey is not available.",
    "survey.open-survey.error-not-in-progress": "This survey is not accepting responses right now.",
    "survey.open-survey.error-response-limit-reached": "This survey isn't accepting more responses this month.",
    "survey.open-survey.error-too-soon": "Your response was already received. If you meant to submit again, please wait a few minutes and try again.",
    "survey.open-survey.loading": "Loading survey...",
    "survey.open-survey.passcode-heading": "Enter your survey passcode",
    "survey.open-survey.passcode-incorrect": "That passcode isn't right. Check it and try again.",
    "survey.open-survey.passcode-label": "Enter your Passcode",
    "survey.return": "Return to Survey",
    "survey.schedule.messaging.preset.slack.1.body": "{{companyName}} would value your feedback. Please take a moment to complete this short survey. Your responses are anonymous and this link is unique to you, so please don't share it.\n\n{{surveyUrl}}",
    "survey.schedule.messaging.preset.sms.1.body": "{{companyName}} values your voice. Please take a moment to complete this survey. Your feedback is unique to you, so please don't share this link.\n\n{{surveyUrl}}\n\nMsg & data rates may apply. Reply STOP to unsubscribe.",
    "survey.schedule.messaging.preset.sms.10.body": "{{companyName}} invites you to complete an employee survey. This link belongs to you. Please do not share it.\n\n{{surveyUrl}}\n\nMsg & data rates may apply. Reply STOP to unsubscribe.",
    "survey.schedule.messaging.preset.sms.2.body": "{{companyName}}: Your opinion matters. Complete your confidential employee survey here (link is unique to you, please don't share):\n\n{{surveyUrl}}\n\nMsg & data rates may apply. Reply STOP to unsubscribe.",
    "survey.schedule.messaging.preset.sms.3.body": "{{companyName}} is conducting its employee survey. Your input is requested and appreciated.\nYour link is unique, please do not forward it.\n\n{{surveyUrl}}\n\nMsg & data rates may apply. Reply STOP to unsubscribe.",
    "survey.schedule.messaging.preset.sms.4.body": "Hi! {{companyName}} wants to hear from you. Your honest thoughts help us build a better workplace for everyone.\nThis link is just for you, so please keep it to yourself.\n\n{{surveyUrl}}\n\nMsg & data rates may apply. Reply STOP to unsubscribe.",
    "survey.schedule.messaging.preset.sms.5.body": "{{companyName}} survey, takes 2 minutes. Your link (don't share):\n\n{{surveyUrl}}\n\nMsg & data rates may apply. Reply STOP to unsubscribe.",
    "survey.schedule.messaging.preset.sms.6.body": "{{companyName}} needs your feedback, just a few minutes. Your voice shapes what comes next.\nTap the link to get started. It's unique to you, don't share it.\n\n{{surveyUrl}}\n\nMsg & data rates may apply. Reply STOP to unsubscribe.",
    "survey.schedule.messaging.preset.sms.7.body": "At {{companyName}}, we grow together. That means listening to every voice, including yours.\nPlease complete this brief survey. This link is unique to you.\n\n{{surveyUrl}}\n\nMsg & data rates may apply. Reply STOP to unsubscribe.",
    "survey.schedule.messaging.preset.sms.8.body": "Thank you for everything you bring to {{companyName}}. We'd love to hear how you're doing! This quick survey is your chance to share honest thoughts.\nYour link is unique, please don't share it.\n\n{{surveyUrl}}\n\nMsg & data rates may apply. Reply STOP to unsubscribe.",
    "survey.schedule.messaging.preset.sms.9.body": "Hey team! {{companyName}} wants to hear from you. It only takes a few minutes. Your survey link (unique to you, please don't share):\n\n{{surveyUrl}}\n\nMsg & data rates may apply. Reply STOP to unsubscribe.",
    "survey.submit": "Submit",
    "survey.thanks.greeting": "Thank you!",
    "survey.thanks.message": "Your responses have been submitted successfully.",
    "survey.timeout-warning": "There hasn't been any activity so we're automatically logging you out in {{timeout}} seconds to protect your confidentiality.",
    "survey.tryagain": "Try again",
    "survey.type.attributebased": "Attribute Based",
    "surveyEmail.defaultContent": "<p>The only way we can improve as an organization is by hearing the voice of our employees.</p><br /><p>Please fill out the survey by clicking on the link below and offer us your honest feedback. Your feedback is always anonymous.</p>",
    "surveyEmail.defaultTitle": "We need your feedback",
    "swal.button.ok": "OK",
    "swal.confirm.cancel": "Cancel",
    "swal.confirm.yes": "Yes",
    "swal.timeout.header": "Are you still there?",
    "tableview.outof": "Out of",
    "text.ariaLabel": "Enter your comment for {{question}}",
    "user.notice": "Privacy notice",
    "user.policy": "Privacy policy",
    "user.terms": "Terms of use",
    "warning.anonymous": "This conversation is completely anonymous",
    "404.description": "We can't find the page you're looking for.",
    "404.title": "There seems to be a problem.",
    "ANONYMOUS_CONVERSATIONS": "Anonymous Conversations",
    "Action": "Action",
    "Africa/Cairo": "({{timezoneOffset}}) Cairo",
    "Africa/Harare": "({{timezoneOffset}}) Harare, Pretoria",
    "Africa/Lagos": "({{timezoneOffset}}) West Central Africa",
    "Africa/Monrovia": "({{timezoneOffset}}) Casablanca, Monrovia",
    "Africa/Nairobi": "({{timezoneOffset}}) Nairobi",
    "America/Anchorage": "({{timezoneOffset}}) Alaska",
    "America/Argentina/Buenos_Aires": "({{timezoneOffset}}) Buenos Aires, Georgetown",
    "America/Bogota": "({{timezoneOffset}}) Bogota, Lima, Quito",
    "America/Chihuahua": "({{timezoneOffset}}) Chihuahua, La Paz, Mazatlan",
    "America/Costa_Rica": "({{timezoneOffset}}) Central America",
    "America/Edmonton": "({{timezoneOffset}}) Mountain Time (US and Canada)",
    "America/Godthab": "({{timezoneOffset}}) Greenland",
    "America/Halifax": "({{timezoneOffset}}) Atlantic Time (Canada)",
    "America/Indiana/Indianapolis": "({{timezoneOffset}}) Indiana (East)",
    "America/La_Paz": "({{timezoneOffset}}) Caracas, La Paz",
    "America/Monterrey": "({{timezoneOffset}}) Guadalajara, Mexico City, Monterrey",
    "America/Phoenix": "({{timezoneOffset}}) Arizona",
    "America/Regina": "({{timezoneOffset}}) Saskatchewan",
    "America/Santiago": "({{timezoneOffset}}) Santiago",
    "America/Sao_Paulo": "({{timezoneOffset}}) Brasilia",
    "America/St_Johns": "({{timezoneOffset}}) Newfoundland and Labrador",
    "America/Toronto": "({{timezoneOffset}}) Eastern Time (US and Canada)",
    "America/Vancouver": "({{timezoneOffset}}) Pacific Time (US and Canada); Tijuana",
    "America/Winnipeg": "({{timezoneOffset}}) Central Time (US and Canada)",
    "Asia/Almaty": "({{timezoneOffset}}) Astana, Dhaka",
    "Asia/Baghdad": "({{timezoneOffset}}) Baghdad",
    "Asia/Baku": "({{timezoneOffset}}) Baku, Tbilisi, Yerevan",
    "Asia/Bangkok": "({{timezoneOffset}}) Bangkok, Hanoi, Jakarta",
    "Asia/Calcutta": "({{timezoneOffset}}) Chennai, Kolkata, Mumbai, New Delhi",
    "Asia/Colombo": "({{timezoneOffset}}) Sri Jayawardenepura",
    "Asia/Irkutsk": "({{timezoneOffset}}) Irkutsk, Ulaanbaatar",
    "Asia/Jerusalem": "({{timezoneOffset}}) Jerusalem",
    "Asia/Kabul": "({{timezoneOffset}}) Kabul",
    "Asia/Kathmandu": "({{timezoneOffset}}) Kathmandu",
    "Asia/Krasnoyarsk": "({{timezoneOffset}}) Krasnoyarsk",
    "Asia/Kuwait": "({{timezoneOffset}}) Kuwait, Riyadh",
    "Asia/Muscat": "({{timezoneOffset}}) Abu Dhabi, Muscat",
    "Asia/Novosibirsk": "({{timezoneOffset}}) Almaty, Novosibirsk",
    "Asia/Rangoon": "({{timezoneOffset}}) Yangon Rangoon",
    "Asia/Seoul": "({{timezoneOffset}}) Seoul",
    "Asia/Shanghai": "({{timezoneOffset}}) Beijing, Chongqing, Hong Kong SAR, Urumqi",
    "Asia/Singapore": "({{timezoneOffset}}) Kuala Lumpur, Singapore",
    "Asia/Taipei": "({{timezoneOffset}}) Taipei",
    "Asia/Tashkent": "({{timezoneOffset}}) Islamabad, Karachi, Tashkent",
    "Asia/Tehran": "({{timezoneOffset}}) Tehran",
    "Asia/Tokyo": "({{timezoneOffset}}) Osaka, Sapporo, Tokyo",
    "Asia/Vladivostok": "({{timezoneOffset}}) Vladivostok",
    "Asia/Yakutsk": "({{timezoneOffset}}) Yakutsk",
    "Asia/Yekaterinburg": "({{timezoneOffset}}) Ekaterinburg",
    "Atlantic/Azores": "({{timezoneOffset}}) Azores",
    "Atlantic/Cape_Verde": "({{timezoneOffset}}) Cape Verde Islands",
    "Atlantic/South_Georgia": "({{timezoneOffset}}) Mid-Atlantic",
    "Australia/Adelaide": "({{timezoneOffset}}) Adelaide",
    "Australia/Brisbane": "({{timezoneOffset}}) Brisbane",
    "Australia/Darwin": "({{timezoneOffset}}) Darwin",
    "Australia/Hobart": "({{timezoneOffset}}) Hobart",
    "Australia/Perth": "({{timezoneOffset}}) Perth",
    "Australia/Sydney": "({{timezoneOffset}}) Canberra, Melbourne, Sydney",
    "Europe/Belgrade": "({{timezoneOffset}}) Sarajevo, Skopje, Warsaw, Zagreb",
    "Europe/Berlin": "({{timezoneOffset}}) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    "Europe/Istanbul": "({{timezoneOffset}}) Bucharest",
    "Europe/London": "({{timezoneOffset}}) Greenwich Mean Time: Dublin, Edinburgh, Lisbon, London",
    "Europe/Minsk": "({{timezoneOffset}}) Athens, Istanbul, Minsk",
    "Europe/Moscow": "({{timezoneOffset}}) Moscow, St. Petersburg, Volgograd",
    "Europe/Paris": "({{timezoneOffset}}) Brussels, Copenhagen, Madrid, Paris",
    "Europe/Riga": "({{timezoneOffset}}) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius",
    "Learning": "Learning",
    "MANAGE_SURVEYS": "Manage Surveys",
    "Pacific/Apia": "({{timezoneOffset}}) Midway Island, Samoa",
    "Pacific/Auckland": "({{timezoneOffset}}) Auckland, Wellington",
    "Pacific/Fiji": "({{timezoneOffset}}) Fiji Islands, Kamchatka, Marshall Islands",
    "Pacific/Guadalcanal": "({{timezoneOffset}}) Magadan, Solomon Islands, New Caledonia",
    "Pacific/Guam": "({{timezoneOffset}}) Guam, Port Moresby",
    "Pacific/Honolulu": "({{timezoneOffset}}) Hawaii",
    "Pacific/Kiritimati": "({{timezoneOffset}}) International Date Line West",
    "Pacific/Tongatapu": "({{timezoneOffset}}) Nuku'alofa",
    "Survey.duplicateName": "Survey Name:",
    "VIEW_OPEN_ENDED_COMMENTS": "View Open Ended Comments",
    "VIEW_REPORTING": "View Reporting",
    "access.all": "All Employees",
    "access.attribute": "Custom Attributes",
    "access.hierarchy": "Their Hierarchy",
    "access.otherHierarchy": "Other Hierarchies",
    "account.email": "Email Address",
    "account.password": "Password",
    "action": "Action",
    "action.added": "Action added",
    "action.added.description": "\"{{title}}\" has been successfully added!",
    "action.created.assigned.message": "%actionOwnerName% has just assigned you the action “%actionTitle%” on WorkTango.",
    "action.created.button.message": "See your action",
    "action.created.link.message": "If the above link does not work, copy and paste the following link into your browser: %baseUrl%/action-planning/actions/%actionId%",
    "action.created.sending.greetings": "Hi",
    "action.created.sending.subject": "You have been assigned a new action on WorkTango",
    "action.updated.button.message": "View Action",
    "action.updated.changes.message": "%actionOwnerName% has made one or more changes to your action “%actionTitle%”.",
    "action.updated.changes.warning": " Please note you may not be able to see the action if you are no longer the action assignee.",
    "action.updated.fields.categoryIds": "Categories",
    "action.updated.fields.description": "Description",
    "action.updated.fields.dueAt": "Due at",
    "action.updated.fields.isComplete": "Is Complete",
    "action.updated.fields.languageId": "Language",
    "action.updated.fields.libraryActionId": "Library Action",
    "action.updated.fields.status": "Status",
    "action.updated.fields.surveyIds": "Surveys",
    "action.updated.fields.title": "Title",
    "action.updated.fields.userIds": "Assignees",
    "action.updated.link.message": "If the above link does not work, copy and paste the following link into your browser: %baseUrl%/action-planning/actions/%actionId%",
    "action.updated.sending.greetings": "Hi",
    "action.updated.sending.subject": "One of your tasks has been updated on WorkTango",
    "actions": "Actions",
    "actions.additional": "Additional reporting permissions",
    "active": "Active",
    "add.action": "Add Action",
    "add.factor": "Add Factor",
    "addCompanyDialog.errors.duplicateName": "This name already exists, please choose a unique name",
    "addCompanyDialog.errors.invalidSalesforceId": "A valid Salesforce ID should be between 15 to 18 characters",
    "addCompanyDialog.name.label": "Company name",
    "addCompanyDialog.salesforce.helperText": "This field is only visible to WorkTango admins",
    "addCompanyDialog.salesforce.label": "Salesforce ID",
    "addCompanyDialog.testDemo.label": "This is a test/demo company",
    "addCompanyDialog.title": "Create a new company",
    "addQuestion": "Add question",
    "admin.ai-prompts.header": "AI Prompts",
    "admin.ai-prompts.sub-title": "These prompts are used to generate question summaries, analysis, key themes and sentiments for all surveys in the platform. Please exercise caution when updating these, because they affect every customer.",
    "admin.ai-prompts.title": "Generative AI Prompts",
    "admin.allowFrench": "Enable French Language",
    "admin.appPermissions": "App Permissions",
    "admin.benchmarks.associate-attribute": "Associate Attribute",
    "admin.benchmarks.associate-attributes": "Associate attributes",
    "admin.benchmarks.associate.filter": "Filter by Company name",
    "admin.benchmarks.associate.subtitle": "Associate employee attributes to benchmark attribute",
    "admin.benchmarks.benchmark-attributes": "Benchmark Attributes",
    "admin.benchmarks.button.go-association": "Go to attribute association for",
    "admin.benchmarks.button.go-mapping": "Go to attribute value mapping for",
    "admin.benchmarks.button.map-selected-to": "Map Selected to",
    "admin.benchmarks.button.map-to": "Map to",
    "admin.benchmarks.button.return-attributes": "Return benchmark attributes",
    "admin.benchmarks.check-new-values": "Check for new values",
    "admin.benchmarks.default-benchmark-value": "Default Benchmark Attribute Value",
    "admin.benchmarks.default-value": "Default Value",
    "admin.benchmarks.header": "Benchmarks",
    "admin.benchmarks.last-refreshed": "Last Refreshed",
    "admin.benchmarks.map-values": "Map values",
    "admin.benchmarks.number-of-values": "# of Values",
    "admin.benchmarks.sample-values": "Sample Values",
    "admin.benchmarks.value-mapping.alert": "You have selected values not finish mapping yet",
    "admin.benchmarks.value-mapping.filter": "Filter by Value",
    "admin.benchmarks.value-mapping.subtitle": "Map employee attribute values to benchmark attribute value",
    "admin.bulk.generate": "Generate Sample File",
    "admin.bulk.sampleFile": "sample file",
    "admin.bulk.selectFile": "Select a CSV/Excel file",
    "admin.company.colour2": "Top Navigation Bar Color",
    "admin.company.cprofile": "Company Logo",
    "admin.company.delete.alert": "All the data related to company {{companyName}} will be DELETED and CAN'T revert later!",
    "admin.company.delete.confirmation": "Please input your account email to confirm deletion",
    "admin.company.industry": "Select Industry",
    "admin.company.manageCompany": "Companies",
    "admin.company.name": "Company Name",
    "admin.company.public": "Public",
    "admin.company.region": "Select Region",
    "admin.company.saved": "Saved!",
    "admin.company.sector": "Sector",
    "admin.companyData.header": "Configuration",
    "admin.companyData.kiosk": "Kiosk",
    "admin.companyData.learning.coach": "Learning Coach",
    "admin.companyData.learning.coach.notifications.enabled": "Notifications enabled",
    "admin.editPermissions": "Edit Permissions",
    "admin.egroup.noemployees": "You have not selected any employees",
    "admin.email.languagesNote": "Note: All enabled language(s) are required",
    "admin.employee.addTagline": "Add New Employee",
    "admin.employee.customcategory": "Create Factor",
    "admin.employee.disableAll": "Disable",
    "admin.employee.edit.custom.category": "Update Factor",
    "admin.employee.enableAll": "Enable",
    "admin.employee.status": "Status",
    "admin.employee.tagline": "Update Employee Details",
    "admin.employees.header": "Employees",
    "admin.employees.tabs.employeeList": "Employee List",
    "admin.employees.tabs.importHistory": "Import History",
    "admin.enable.sso": "Enable SSO",
    "admin.fields.enName": "Field Name(En)",
    "admin.fields.frName": "Field Name(Fr)",
    "admin.fields.header": "Create New Field",
    "admin.fields.isPrivateAttribute": "Hidden in Employee List",
    "admin.fields.isReportingAttribute": "Primary Attribute (always shown by default, up to 10 allowed)",
    "admin.fields.name": "Field Name",
    "admin.fields.required": "Required",
    "admin.fields.systemHeader": "System Field",
    "admin.fields.type": "Type",
    "admin.fields.unique": "Unique",
    "admin.fields.update": "Update Field",
    "admin.kiosk.field": "Kiosk Field",
    "admin.kiosk.url": "Employees can access the kiosk feature using the following URL:",
    "admin.library.header": "Question Library",
    "admin.managePermissions": "Manage Permissions",
    "admin.notify.completion.button": "See my Survey Overview",
    "admin.notify.completion.closed": "has closed.",
    "admin.notify.completion.overview": "Your Survey Overview is now ready for you at WorkTango",
    "admin.notify.expired.click": "Click",
    "admin.notify.expired.extend": "If you would like to extend your survey, simply update the expiry date in your survey settings.",
    "admin.notify.expired.see.results": "to see your results",
    "admin.notify.expired.submitted": "of people have submitted surveys",
    "admin.notify.expired.warn": "has now expired",
    "admin.notify.reminder.opening": "Your survey",
    "admin.notify.reminder.scheduled": "is scheduled to be sent out in",
    "admin.notify.reminder.subject": "Reminder: WorkTango survey is about to be sent",
    "admin.notify.sending.completed.happy.response.rate": "We wish you a 100% response rate :)",
    "admin.notify.sending.completed.senttox": "Your Pulse entitled %surveyname% has been sent out to %sendto% people.",
    "admin.notify.sending.completed.subject": "Sending of %surveyname% is now completed.",
    "admin.notify.sending.greetings": "Your survey entitled",
    "admin.notify.sending.notify.when.complete": "We will email you when the process is complete.",
    "admin.notify.sending.status": "is being processed and will be sent out to",
    "admin.notify.sending.subject": "%surveyname% is being sent out",
    "admin.notify.sending.thanks": "Thanks!",
    "admin.notify.sending.time": "over the next",
    "admin.permission.createSuccessMsg": "You've successfully invited {{num}} new users.",
    "admin.permission.self": "Yourself",
    "admin.permission.updateSuccessMsg": "Permission Updated.",
    "admin.permission.userEmailsTitle": "Enter the users emails separated by commas",
    "admin.previous.header": "Previously Asked Questions",
    "admin.question.addlabels": "Add Labels",
    "admin.question.allowMultiple": "Allow multiple selections",
    "admin.question.category": "Factor",
    "admin.question.commentsRequired": "Allow Comments",
    "admin.question.description": "Add Description",
    "admin.question.emailContent": "Email Content",
    "admin.question.emailSubject": "Email subject",
    "admin.question.fixed": "Icon",
    "admin.question.fromEmailName": "Sender's Name",
    "admin.question.hideReporting": "Hide from reporting",
    "admin.question.labelAfter": "Input right label content here",
    "admin.question.labelBefore": "Input left label content here",
    "admin.question.languagesNote": "Note: All languages are required",
    "admin.question.library": "Question Library",
    "admin.question.multiple": "Multiple Choice",
    "admin.question.name": "Question",
    "admin.question.newmessage": "New Message",
    "admin.question.numratings": "Scale",
    "admin.question.open": "Text",
    "admin.question.options": "Answer Options",
    "admin.question.optionsAllowed": "Options Allowed",
    "admin.question.optionsEditor.actions": "Actions",
    "admin.question.optionsEditor.addOption": "Add an option",
    "admin.question.optionsEditor.importAttributeLabel": "Employee attribute to source options from",
    "admin.question.optionsEditor.importAttributePlaceholder": "Choose an attribute",
    "admin.question.optionsEditor.importButton": "Import",
    "admin.question.optionsEditor.importDescription": "Imported attribute values are sorted alphabetically, and added to the list of existing options.",
    "admin.question.optionsEditor.importEmpty": "This attribute has no new values to import.",
    "admin.question.optionsEditor.importError": "The attribute values could not be loaded. Please try again.",
    "admin.question.optionsEditor.importFromAttribute": "Import options from attribute...",
    "admin.question.optionsEditor.importTitle": "Import options from an Attribute",
    "admin.question.optionsEditor.removeAll": "Remove all options",
    "admin.question.previous": "Previously asked Qs (for trends)",
    "admin.question.reportingFilter": "Reporting filtering options",
    "admin.question.reportingFilter.attribute": "Attribute filter",
    "admin.question.reportingFilter.attributePlaceholder": "Choose an attribute",
    "admin.question.reportingFilter.loadError": "The saved reporting filter could not be loaded. Refresh the page to try again.",
    "admin.question.reportingFilter.none": "Do not use responses as a filter",
    "admin.question.reportingFilter.questionLabel": "Question filter label",
    "admin.question.reportingFilter.useAsAttributeFilter": "Use responses as attribute filter",
    "admin.question.reportingFilter.useAsQuestionFilter": "Use responses as a question filter",
    "admin.question.required": "Required",
    "admin.question.select": "Drop Down",
    "admin.question.shapetype": "Icon Type",
    "admin.question.showSkipButton": "Show skip button",
    "admin.question.sliding": "Rating",
    "admin.question.subject": "Subject",
    "admin.question.yes_no": "Yes/No",
    "admin.reminders.tagline": "This will email all employees that have not yet completed the survey",
    "admin.resendInvites": "Resend Invites",
    "admin.selectedUsers": "Selected Users",
    "admin.setAllPermissions": "Need to copy one user's permissions to the other selected users? Simply click on their name to auto-apply their permissions to all the others.",
    "admin.step4.recipients.header": "Survey Participants",
    "admin.step4.schedule.header": "Schedule",
    "admin.survey-template.activate": "Activate Template",
    "admin.survey-template.build.empty-questions.description": "Start by adding a question to this survey from the library.",
    "admin.survey-template.build.empty-questions.title": "Add your first question!",
    "admin.survey-template.build.question-library.addQuestionsButton": "Add selected questions and return to editor",
    "admin.survey-template.build.question-library.cancelButton": "Cancel and return to editor",
    "admin.survey-template.build.question-library.searchQuestion": "Search for a question...",
    "admin.survey-template.build.question-library.selectFactor": "Select Factor",
    "admin.survey-template.build.survey-questions.add-button": "Add library questions",
    "admin.survey-template.build.survey-questions.description": "There are currently no questions configured for this survey.",
    "admin.survey-template.build.survey-questions.remove-button": "Remove",
    "admin.survey-template.build.survey-questions.title": "Survey questions",
    "admin.survey-template.build.title": "Survey Builder",
    "admin.survey-template.config.style.helper-text": "Surveys created from this template use this style. It cannot be changed once a survey is created.",
    "admin.survey-template.config.title": "Survey Configuration",
    "admin.survey-template.error-message.unique-name": "Survey template name is invalid: A survey template with the same name and language already exists.",
    "admin.survey-template.new-template-title": "New Survey Template",
    "admin.survey-template.share.note": "Note: All enabled languages are required",
    "admin.survey-template.share.title": "Survey invitation email",
    "admin.survey-template.title-details": "Your Survey Details",
    "admin.survey-template.unsaved-changes": "You have unsaved changes on this page.",
    "admin.survey.addTagline": "Create New Survey",
    "admin.survey.allSurveyStatus": "All Survey Status",
    "admin.survey.allSurveyStyles": "All Survey Styles",
    "admin.survey.allSurveyTypes": "All Survey Types",
    "admin.survey.anonMessage": "Leaders will be able to respond to employee's comments",
    "admin.survey.anons": "Enable Anonymous Conversations",
    "admin.survey.audience-mode": "Audience",
    "admin.survey.audience-mode.helper-text": "Please note: This setting cannot be changed",
    "admin.survey.audience-mode.individual.description": "Invite specific employees. Each participant receives their own link and can respond once.",
    "admin.survey.audience-mode.individual.title": "Individual Link",
    "admin.survey.audience-mode.shared.description": "Publish a single link that anyone can open. Responses are anonymous and there is no limit on how many can be submitted.",
    "admin.survey.audience-mode.shared.title": "Shared Link",
    "admin.survey.build.add-recipient.alert.inprogress": "Once confirmed, an email will be sent to {{count}} employee(s) shortly.",
    "admin.survey.build.add-recipient.alert.scheduled": "Once confirmed, new recipient(s) will be added to this survey.",
    "admin.survey.build.add-recipient.title": "Add {{count}} New Recipient(s)?",
    "admin.survey.build.add-recipient.title_other": "Add {{count}} New Recipients?",
    "admin.survey.build.add-remove.alert.inprogress": "Once confirmed, an email will be sent to {{addCount}} employee(s) shortly, {{removeCount}} recipient(s) survey links will no longer be valid and any results will be removed from the survey.",
    "admin.survey.build.add-remove.alert.scheduled": "Once confirmed, recipient(s) will be added or removed",
    "admin.survey.build.add-remove.title": "Add {{addCount}} New Recipient(s), and remove {{removeCount}} Recipient(s)?",
    "admin.survey.build.archived_invitation": "This is an archived invitation that was created automatically when this employee was rehired. It serves as an accurate representation of participation rate, and a link to survey responses, if the person submitted them.",
    "admin.survey.build.automate.activate.success": "Continuous survey successfully moved to in progress",
    "admin.survey.build.automate.deactivate.success": "Continuous survey successfully moved to Completed",
    "admin.survey.build.automate.save.changes.close": "Save changes and close",
    "admin.survey.build.automate.title": "Survey Automation",
    "admin.survey.build.candidates": "Survey Candidates",
    "admin.survey.build.candidates.description": "The system identified the following employees to be invited to fill out their survey on their targeted date.",
    "admin.survey.build.candidates.empty": "There are no candidates waiting to be invited in this survey. Automation triggers will handle invitations based on Start or Exit date.",
    "admin.survey.build.candidates.outbox-button": "Update candidates in the outbox",
    "admin.survey.build.candidates.search": "Filter by name",
    "admin.survey.build.disable-emails.alert.description": "This survey will not be sending email invitations and reminders to participants. Make sure to configure kiosk access where employees can submit their responses.",
    "admin.survey.build.disable-emails.alert.title": "Email sending disabled",
    "admin.survey.build.disable-emails.dialog.confirm": "Disable email sending",
    "admin.survey.build.disable-emails.dialog.description1": "Turning off sending emails means that the participants will not be invited to this survey, or reminded to complete the survey if they haven't done so yet.",
    "admin.survey.build.disable-emails.dialog.description2": "The only way for employees can access this survey is via kiosk link, so make sure to set one up.",
    "admin.survey.build.disable-emails.dialog.description3": "Do you still want to turn off sending of emails?",
    "admin.survey.build.disable-emails.dialog.title": "Disable sending emails for this survey",
    "admin.survey.build.disable-emails.switch": "Enable sending of email invitations and reminders to participants",
    "admin.survey.build.expired": "Survey expires on:",
    "admin.survey.build.invitation-expires-at": "Invitations for these employees expires on:",
    "admin.survey.build.leave.alert": "You have unsaved changes to the recipient list.",
    "admin.survey.build.leave.dialog.body_1": "You made changes to the participants lists, but didn’t save them.",
    "admin.survey.build.leave.dialog.body_2": "Are you sure you want to leave without saving changes?",
    "admin.survey.build.leave.dialog.title": "Survey participants update",
    "admin.survey.build.leave.leave_step": "Leave without saving",
    "admin.survey.build.leave.stay_step": "Stay on this step",
    "admin.survey.build.leave.title": "Do you want to leave? There are unsaved changes",
    "admin.survey.build.remove-recipient.alert.inprogress": "Once confirmed, survey links for {{count}} recipient(s) will no longer be valid and any results will be removed from the survey.",
    "admin.survey.build.remove-recipient.alert.scheduled": "Once confirmed, {{count}} recipient(s) will be removed from this survey.",
    "admin.survey.build.remove-recipient.title": "Remove {{count}} Recipient(s)?",
    "admin.survey.build.save-alert": "Recipient List has been modified, click ‘Save’ to save your changes",
    "admin.survey.build.scheduled": "Survey scheduled from:",
    "admin.survey.build.triggers": "Survey Triggers",
    "admin.survey.build.triggers.description": "Following trigger(s) are configured to automatically invite employees to this survey based on their {{attribute}}",
    "admin.survey.build.triggers.empty": "There are no triggers configured for this survey. Click below to configure the first one.",
    "admin.survey.build.update-alert": "Recipient List has been modified, click ‘Update’ to save your changes",
    "admin.survey.cancelled": "Survey scheduling has been cancelled",
    "admin.survey.combineLanguages": "Combine all languages into one email",
    "admin.survey.combineLanguagesMessage": "Sends invitations in a single email message with all languages, regardless of employee language preference.",
    "admin.survey.configure.title": "Survey configuration",
    "admin.survey.continuous": "Continuous",
    "admin.survey.duplicated": "Looks like there is already a survey with the same name. Please choose a different survey name to continue.",
    "admin.survey.emailLanguage": "Email Languages",
    "admin.survey.endDate": "Expiry",
    "admin.survey.endTime": "Expiry Time",
    "admin.survey.endafterstart": "Please select an Expiry Date after the Scheduled Send Date",
    "admin.survey.expired": "Will Expire:",
    "admin.survey.fromEmail": "Send from",
    "admin.survey.fromemailnamecheck": "You must include the email sender name",
    "admin.survey.futureStart": "Please select a date in the future based on timezone selected",
    "admin.survey.graph.tooltip.total": "Total",
    "admin.survey.languages": "Language(s)",
    "admin.survey.leave": "Leave site? Changes you made may not be saved",
    "admin.survey.name": "Survey Name",
    "admin.survey.name.placeholder": "Enter survey name",
    "admin.survey.new": "New survey",
    "admin.survey.notification-dialog.description-1": "Survey template you chose to create this survey from featured questions that were referencing Factors that were not present in your configuration.",
    "admin.survey.notification-dialog.description-2": "As a result of this, one or more questions will require you to manually select appropriate Factors in order to properly save the survey.",
    "admin.survey.notification-dialog.title": "One or more questions are missing Factors",
    "admin.survey.numquestions": "Total Questions:",
    "admin.survey.numrecipients": "Number of Total Recipients:",
    "admin.survey.option": "Option {{num}}",
    "admin.survey.pasteEmail": "Paste Emails",
    "admin.survey.pasteEmailError": "The following employee email does not exist: {{emails}}",
    "admin.survey.pasteEmailInvalid": "The following email has wrong format: {{emails}}",
    "admin.survey.pasteEmailSuccess": "Added {{total}} new recipients",
    "admin.survey.preferTimezone": "Preferred Timezone",
    "admin.survey.preview": "Preview",
    "admin.survey.scheduled": "Scheduled For:",
    "admin.survey.searchName": "Enter survey name",
    "admin.survey.selected": "Selected",
    "admin.survey.send.test.btn.title": "Send a test email to yourself",
    "admin.survey.sentDate": "Sent Date",
    "admin.survey.showResults": "Show Survey Results",
    "admin.survey.showResultsMessage": "Shows total results to employees after completing survey",
    "admin.survey.standard": "Standard",
    "admin.survey.startDate": "Start Date",
    "admin.survey.startTime": "Send Time",
    "admin.survey.step1": "Configure",
    "admin.survey.step2": "Build",
    "admin.survey.step4": "Share",
    "admin.survey.step5": "Automate",
    "admin.survey.style": "Survey Style",
    "admin.survey.style.continuous.description": "This survey does not expire, but invitations do, and participants can still respond only once. Reporting is performed based on selected timeframes. Ideal for Onboarding and Exit surveys.",
    "admin.survey.style.continuous.exit-date.description": "Ideal for Exit surveys. This survey does not expire, but invitations do, and participants can still respond only once. Reporting is performed based on selected timeframes.",
    "admin.survey.style.continuous.exit-date.title": "Continuous survey based on Exit Date",
    "admin.survey.style.continuous.start-date.description": "Ideal for Onboarding surveys. This survey does not expire, but invitations do, and participants can still respond only once. Reporting is performed based on selected timeframes.",
    "admin.survey.style.continuous.start-date.title": "Continuous survey based on Start Date",
    "admin.survey.style.continuous.title": "Continuous survey",
    "admin.survey.style.helper-text": "Please note: This setting cannot be changed",
    "admin.survey.style.shared-link.description": "This survey is shared via a single link instead of individual invitations, so respondents don't need to be in your employee file, and they can respond more than once.",
    "admin.survey.style.shared-link.description-limitations": "Because no one is identified, there's no invitations, response rates, and reminders don't apply.",
    "admin.survey.style.shared-link.title": "Shared Link survey",
    "admin.survey.style.standard.description": "This survey has fixed start and end dates, after which it can take no more responses. For trending purposes, you can clone it and re-invite participants.",
    "admin.survey.style.standard.title": "Standard survey",
    "admin.survey.surveyNameMax": "Maximum {{num}} characters allowed",
    "admin.survey.timezone": "Timezone",
    "admin.survey.type": "Type",
    "admin.survey.type.placeholder": "Choose type",
    "admin.survey.wizard.next-step": "Next step",
    "admin.survey.wizard.previous-step": "Previous step",
    "admin.survey.wizard.return-to-surveys": "Return to surveys",
    "admin.survey.wizard.save-changes": "Save changes",
    "admin.surveylibrary.count": "# of times Sent",
    "admin.surveylibrary.lastSent": "Last Sent",
    "admin.surveylibrary.supportedLanguages": "Supported Languages",
    "admin.surveylibrary.type": "Question Type",
    "admin.surveyquestions.header": "Add Questions to survey",
    "admin.surveys.detail": "Your Survey Details",
    "admin.surveys.header": "Surveys",
    "admin.title": "Admin",
    "admin.updatesurvey.add": "Add",
    "admin.updatesurvey.remove": "Remove",
    "admin.updatesurvey.resend": "Resend",
    "admin.users.action-planning-perms": "Action Planning Permissions",
    "admin.users.allAttributes": "All Attributes",
    "admin.users.attribute.selected": "{{num}} selected",
    "admin.users.attribute.selector": "Attributes that users can see",
    "admin.users.attributes.compareAttributesDoNotMatchFilterAttributes": "Every attribute on the \"<0>{{compareAttributesHeader}}</0>\" list must also be present on the \"<0>{{filterAttributesHeader}}</0>\" list.",
    "admin.users.attributes.header": "Filtering Attributes",
    "admin.users.customAttributes": "Custom Attributes",
    "admin.users.dataAccess": "Data Access",
    "admin.users.dataAccess.all": "Sending surveys and viewing survey results",
    "admin.users.dataAccess.sendingOnly": "Sending surveys",
    "admin.users.dataAccess.viewOnly": "Viewing survey results",
    "admin.users.dataCompare": "Data Comparables in Reporting",
    "admin.users.editUser": "Edit what other user have access to.",
    "admin.users.email": "Email",
    "admin.users.exist.email": "User already exist: {{emails}}",
    "admin.users.header": "Users",
    "admin.users.invite": "Invite Users",
    "admin.users.manage": "Manage User",
    "admin.users.missing.compareValue": "Please select attributes for data comparables for survey type {{name}}",
    "admin.users.missing.dataAccess": "Please select attributes for employee data access for survey type {{name}}",
    "admin.users.missing.email": "Please provide an email",
    "admin.users.missing.employeeAccess": "Please select one option for employee data access for survey type {{name}}",
    "admin.users.missing.language": "Please select a language",
    "admin.users.missing.surveyType": "At least one survey type permission required",
    "admin.users.missing.visibility": "Please select attributes for attributes data access for survey type {{name}}",
    "admin.users.name": "Name",
    "admin.users.no.email": "In order to invite users with hierarchy-based access or attribute-based access, they need to be listed as an employee: {{email}}",
    "admin.users.permissions": "Company Permissions",
    "admin.users.searchAll": "Search by name or email",
    "admin.users.selectAttributeValues": "Select Attribute Values",
    "admin.users.selectAttributes": "Select Attributes",
    "admin.users.selectHierarchies": "Select Hierarchies",
    "admin.users.surveyPermissions": "Survey Type Permissions",
    "admin.users.tagline": "Invite others to access survey creation, view all survey results, and/or view restricted survey results for their direct reports only.",
    "admin.users.theirType": "Their {{name}}",
    "admin.users.userActions": "User Actions",
    "adminExport.advanced": "Advanced Version",
    "adminExport.confirm.desc": "Advanced version contains sensitive user data.",
    "adminExport.confirm.title": "Are you sure you need advanced version?",
    "adminExport.desc": "The raw export will include all the employee attribute data including the employee’s ID, manager’s ID and email address. This is all the info needed for a regen.",
    "adminExport.dialog.confirm": "Download Export",
    "adminExport.includePrivateAttributes": "Include employee's private attributes",
    "adminExport.includeResponses": "Include employee responses",
    "adminExport.privateAttributes.warning.confirm": "Yup! I need the employee's private attributes and agree to delete this export as soon as I’m done with it",
    "adminExport.privateAttributes.warning.desc": "Employee's private attributes are sensitive and related directly to a single person. This data should not be shared. Your User ID will be recorded.",
    "adminExport.privateAttributes.warning.title": "Are you sure you need to export the employee's private attributes?",
    "adminExport.title": "Raw Export",
    "adminExport.warning.confirm": "Yup! I need the employee responses and agree to delete this export as soon as I’m done with it",
    "adminExport.warning.desc": "Employee responses are not needed to regenerate a survey. This option should only be chosen for analysis purposes. Your User ID will be recorded.",
    "adminExport.warningTitle": "Are you sure you need to export the employee responses?",
    "ago": "ago.",
    "ai.email.next.steps": "These insights provide a valuable starting point for a conversation and action. To dig deeper into the data and understand the nuances behind these numbers, we encourage you to use the AI assistant directly within the WorkTango platform. You can engage the WorkTango Coach to help you explore the findings and walk through effective strategies for responding to your team's feedback.",
    "ai.email.presentation": "Your Survey Overview is now ready for you at WorkTango. Here is a brief summary of your team’s results.",
    "allQuestions": "All Questions",
    "analytics.distribution": "Distribution",
    "analytics.fields": "Employee Fields",
    "analytics.hierarchy": "Hierarchy",
    "analytics.nps": "eNPS",
    "analyze.attribute.noVisible": "No primary attribute visible for current survey",
    "analyze.hide.empty.rows": "Hide empty rows",
    "and": "and",
    "anonymouse.protection.message": "In order to protect the confidentiality of employees, we can't display the requested data. WorkTango’s confidentiality algorithms are in place to ensure employees feel safe while providing their feedback. Please try changing the selected survey(s) and/or filter(s).",
    "ap.actionWasCreatedSuccessfully": "Your action has been created and assigned successfully.",
    "ap.add.action": "Add to Actions",
    "ap.createALibraryTemplate": "Create a Library Action",
    "ap.createAnAction": "Create an action",
    "ap.edit.template": "Edit Library Action",
    "ap.error.assignmentRequired": "You must assign to someone",
    "ap.error.titleRequired": "Titles are required for all languages.",
    "ap.label.addAction": "Add action",
    "ap.label.addQuestion": "Add Question",
    "ap.label.any": "Any",
    "ap.label.anyone": "Anyone",
    "ap.label.assignedTo": "Assigned to",
    "ap.label.cancel": "Cancel",
    "ap.label.changeDueDate": "Change due date",
    "ap.label.close": "Close",
    "ap.label.create": "Create",
    "ap.label.description": "Description",
    "ap.label.dueAt": "Due at",
    "ap.label.effectiveness": "Effectiveness",
    "ap.label.factors": "Factors",
    "ap.label.filterBy": "Filter by:",
    "ap.label.introduce.question": "Introduce new question",
    "ap.label.me": "Me",
    "ap.label.modifyAction": "Modify Action",
    "ap.label.newAction": "New Action",
    "ap.label.reset": "Reset",
    "ap.label.save": "Save",
    "ap.label.search": "Search",
    "ap.label.status": "Status",
    "ap.label.surveyFactor": "Default Survey-Factor",
    "ap.label.surveyType": "Survey Type",
    "ap.label.surveys": "Surveys",
    "ap.label.title": "Title",
    "ap.noActions": "Need a way to follow up on your organization's insights?",
    "ap.noFilterResults": "No actions found for the filters selected. Try a different set of filters.",
    "ap.noLibraryTemplates": "No Library Actions",
    "ap.status.complete": "Completed",
    "ap.status.inProgress": "Mark as completed",
    "ap.status.todo": "To Do",
    "ap.status.unassigned": "Unassigned",
    "ap.title.actionAssigned": "Action Added",
    "ap.title.actionPlanning": "Action Planning",
    "ap.title.actions": "Actions",
    "ap.title.assignedTo": "Assigned to",
    "ap.title.createLibraryAction": "Create Library Action",
    "ap.title.dueAt": "Due at",
    "ap.title.factors": "Factors",
    "ap.title.isComplete": "Done",
    "ap.title.library": "Library",
    "ap.title.libraryAction": "Library Action",
    "ap.title.modifyLibraryAction": "Modify Library Action",
    "ap.title.name": "Name",
    "ap.title.surveys": "Surveys",
    "ar-sa": "Arabic (Saudi Arabia)",
    "are-you-sure": "Click to confirm deletion",
    "are.you.sure": "Are you sure?",
    "attribute": "Attribute",
    "attribute-list.no-attributes": "There are no attributes to show. Please double-check your permissions, or enter in contact with support.",
    "attribute-list.not-available": "Not available",
    "attribute-list.not-available-tooltip": "You do not have permissions to view this attribute's values",
    "attribute.breakdown": "Attribute Breakdown",
    "attribute.click.to.confirm.archive": "Click to confirm archiving",
    "attribute.click.to.confirm.unarchive": "Click to confirm reactivation",
    "attribute.create": "Create",
    "attribute.empty.message": "Select an attribute to continue",
    "attribute.endDate": "End Date",
    "attribute.name": "Attribute Name",
    "attribute.startDate": "Start Date",
    "attribute.unarchive": "Reactivate attribute",
    "attribute.unarchiveConfirmTitle": "Reactivate attribute \"{{name}}\"?",
    "attributes.all": "All Attributes",
    "attributes.label": "Attribute",
    "automated-invitations.add-another-trigger": "Add another trigger",
    "automated-invitations.add-trigger": "Add trigger",
    "automated-invitations.box.switch": "Automate sending {{surveyType}} Survey invitations",
    "automated-invitations.box.title": "{{surveyType}} Surveys",
    "automated-invitations.confirm-delete-dialog.delete": "yes, delete trigger",
    "automated-invitations.confirm-delete-dialog.delete-with-candidates": "Delete Trigger and Candidates",
    "automated-invitations.confirm-delete-dialog.message1": "Deleting a trigger will only affect future employee file automations. <0>This action cannot be undone.</0>",
    "automated-invitations.confirm-delete-dialog.message2": "If your intent is to halt automation, but preserve trigger configuration, consider pausing the trigger or toggling survey automation instead.",
    "automated-invitations.confirm-delete-dialog.message3": "Are you sure you want to delete this trigger?",
    "automated-invitations.confirm-delete-dialog.message4": "Remove candidates added through this trigger",
    "automated-invitations.confirm-delete-dialog.message5": "All employees currently in the Outbox that were added through this trigger will be affected by this action",
    "automated-invitations.confirm-delete-dialog.title": "Delete Trigger \"{{triggerName}}\"?",
    "automated-invitations.confirm-disable-dialog.halt-automation": "yes, halt automation",
    "automated-invitations.confirm-disable-dialog.message1": "Halting this process will only affect future employee file automations. This action can be easily reverted.",
    "automated-invitations.confirm-disable-dialog.message2": "All previously invited employees and those currently in the Outbox will not be affected by this action, and you can always re-enable this automation in the future.",
    "automated-invitations.confirm-disable-dialog.message3": "If you proceed, all configured triggers will be preserved, but will not be active.",
    "automated-invitations.confirm-disable-dialog.message4": "Are you sure you want to halt the automation?",
    "automated-invitations.confirm-disable-dialog.success": "Automation halted successfully.",
    "automated-invitations.confirm-disable-dialog.title": "Stop automating {{surveyType}} Surveys?",
    "automated-invitations.confirm-pause-dialog.pause-message": "Pausing a trigger will only stop future employees from being added to the list. Candidates already on the list will not be affected. This action can be easily reverted.\n<0/>\nYou can unpause a trigger anytime to resume automation, which will look for matching employees.\n<0/>\nAre you sure you want to pause this trigger?",
    "automated-invitations.confirm-pause-dialog.pause-title": "Pause Trigger \"{{triggerName}}\"?",
    "automated-invitations.confirm-pause-dialog.unpause-message": "Unpausing a trigger will resume automation, which will look for matching employees to invite them to participate in the survey.\n<0/>\nAre you sure you want to unpause this trigger?",
    "automated-invitations.confirm-pause-dialog.unpause-title": "Unpause Trigger \"{{triggerName}}\"?",
    "automated-invitations.rehiring.attribute-containing-rehire-date": "Attribute containing Rehire Date",
    "automated-invitations.rehiring.description": "The system can identify if an employee has rejoined the company, and will allow for multiple participations in Onboarding and Exit surveys. The original survey invitation and responses will be preserved.",
    "automated-invitations.rehiring.rehire-date-save-failed": "Rehire Date configuration could not be saved, please try again.",
    "automated-invitations.rehiring.rehire-date-saved": "Rehire Date configuration successfully saved.",
    "automated-invitations.rehiring.rehire-warning": "Please note that this change will only affect future Rehire Date changes, and will not update existing employees. In case this attribute becomes unavailable in the future (archived or deleted), the system will automatically revert back to Start Date.",
    "automated-invitations.rehiring.title": "Rehiring",
    "automated-invitations.these-triggers": "These trigger are...",
    "automated-invitations.trigger-form.actions": "Trigger Actions",
    "automated-invitations.trigger-form.admin-users-helper": "This is an internal field visible only to Platform Administrators",
    "automated-invitations.trigger-form.all-users-error": "Pick a user or platform admin. At least one person needs to be notified before and after invitations are sent",
    "automated-invitations.trigger-form.attribute": "Attribute containing {{attribute}}",
    "automated-invitations.trigger-form.attribute-error": "Date required to calculate the right time to send an invite",
    "automated-invitations.trigger-form.attribute-placeholder": "Choose an attribute",
    "automated-invitations.trigger-form.attributes-audience-error": "Please select at least one filter if you’re using attribute based audience",
    "automated-invitations.trigger-form.automation-level": "Automation level",
    "automated-invitations.trigger-form.automation-level.automatic": "Email invitation should go out automatically",
    "automated-invitations.trigger-form.automation-level.manual": "Admin needs to approve the recipients",
    "automated-invitations.trigger-form.cancel": "Cancel",
    "automated-invitations.trigger-form.custom": "Custom",
    "automated-invitations.trigger-form.custom-date.description.exit": "{{days}} days before exit",
    "automated-invitations.trigger-form.custom-date.description.onboarding": "{{days}} days into the tenure",
    "automated-invitations.trigger-form.custom-invitation-date": "Custom target invitation date",
    "automated-invitations.trigger-form.custom-view": "Custom ({{description}})",
    "automated-invitations.trigger-form.delete": "Delete trigger...",
    "automated-invitations.trigger-form.delete-success": "Trigger deleted successfully.",
    "automated-invitations.trigger-form.edit": "Edit trigger",
    "automated-invitations.trigger-form.invitation-date": "Targeted invitation date",
    "automated-invitations.trigger-form.invitation-date.30-days-after": "30 days into the tenure",
    "automated-invitations.trigger-form.invitation-date.60-days-after": "60 days into the tenure",
    "automated-invitations.trigger-form.invitation-date.90-days-after": "90 days into the tenure",
    "automated-invitations.trigger-form.invitation-date.exit-15-days-before": "15 days before exit",
    "automated-invitations.trigger-form.invitation-date.exit-7-days-before": "7 days before exit",
    "automated-invitations.trigger-form.invitation-date.exit-asap": "As soon as possible",
    "automated-invitations.trigger-form.invitation-date.exit-date": "On the exit date",
    "automated-invitations.trigger-form.invitation-date.start-date": "On the start date",
    "automated-invitations.trigger-form.invitation-date.week-before": "Week before start date",
    "automated-invitations.trigger-form.invitation-time": "Time of day to send the invitation",
    "automated-invitations.trigger-form.invitation-time.end-of-day": "End of day (4-6pm)",
    "automated-invitations.trigger-form.invitation-time.lunch": "Noon to lunch (12pm-2pm)",
    "automated-invitations.trigger-form.invitation-time.morning": "Early morning (6-8am)",
    "automated-invitations.trigger-form.invitation-time.night": "Late night (8-10pm)",
    "automated-invitations.trigger-form.invitation-time.tooltip": "This is when your invitations enter the send queue, not necessarily when recipients receive them. Please note that the delivery may take up to 3 hours after the window starts to maintain email deliverability standards.",
    "automated-invitations.trigger-form.name": "Trigger name",
    "automated-invitations.trigger-form.name-error": "Unique internal name required",
    "automated-invitations.trigger-form.name-placeholder": "Enter an internal trigger name",
    "automated-invitations.trigger-form.new-trigger-title": "New trigger",
    "automated-invitations.trigger-form.notified-admin-users": "Platform Administrators who should get email notifications",
    "automated-invitations.trigger-form.notified-users": "Users who should get email notifications",
    "automated-invitations.trigger-form.pause": "Pause trigger...",
    "automated-invitations.trigger-form.pause-confirmation": "Yes, pause it",
    "automated-invitations.trigger-form.pause-success": "Trigger paused successfully.",
    "automated-invitations.trigger-form.save": "Save trigger",
    "automated-invitations.trigger-form.survey": "{{surveyType}} survey to invite to",
    "automated-invitations.trigger-form.survey-error": "Please select a survey that employees should get invited to",
    "automated-invitations.trigger-form.survey-placeholder": "Choose a survey",
    "automated-invitations.trigger-form.target-audience": "Target audience",
    "automated-invitations.trigger-form.target-audience.attribute": "Attribute based",
    "automated-invitations.trigger-form.target-audience.everyone": "Everyone",
    "automated-invitations.trigger-form.timezone": "{{timezone}}, as per survey",
    "automated-invitations.trigger-form.unpause": "Unpause trigger...",
    "automated-invitations.trigger-form.unpause-confirmation": "Yes, unpause it",
    "automated-invitations.trigger-form.unpause-success": "Trigger unpaused successfully.",
    "automated-invitations.trigger-form.users-error": "At least one person needs to be notified before and after invitations are sent",
    "back.to.login": "Back to Login",
    "benchmark.attribute.country": "country",
    "benchmark.attribute.industry": "industry",
    "benchmark.attribute.region": "region",
    "benchmark.attribute.sector": "sector",
    "benchmark.attribute.size": "size",
    "benchmark.comment.insufficient-data": "Insufficient data (N={{companiesCount}})",
    "benchmark.comment.question-not-benchmarked": "Question not benchmarked",
    "benchmark.compare.menu-item": "WorkTango Benchmark {{benchmarkPeriod}}",
    "benchmark.dropdown.label": "Benchmarking against",
    "benchmark.option-group.different-organization": "Different than your organization",
    "benchmark.option-group.same-organization": "Same as your organization",
    "benchmark.option.all-companies": "All companies",
    "benchmark.option.other-country": "Other country...",
    "benchmark.option.other-industry": "Other industry...",
    "benchmark.option.other-region": "Other region...",
    "benchmark.option.other-sector": "Other sector...",
    "benchmark.option.other-size": "Other size...",
    "benchmark.option.same-country": "Same country ({{countryName}})",
    "benchmark.option.same-industry": "Same industry ({{industryName}})",
    "benchmark.option.same-region": "Same region ({{regionName}})",
    "benchmark.option.same-sector": "Same sector ({{sectorName}})",
    "benchmark.option.same-size": "Same size ({{sizeName}})",
    "benchmark.option.top25-companies": "Top Quartile highest scoring companies",
    "benchmark.question-mapping.all-companies": "All companies",
    "benchmark.question-mapping.all-questions": "All questions",
    "benchmark.question-mapping.all-survey-types": "All survey types",
    "benchmark.question-mapping.all-years": "All years",
    "benchmark.question-mapping.empty": "There are no questions matching your filters.",
    "benchmark.question-mapping.filter-question": "Filter by question",
    "benchmark.question-mapping.library-question": "Library question",
    "benchmark.question-mapping.not-tagged-msg": "Question not used for benchmark",
    "benchmark.question-mapping.number-of-surveys": "# of surveys",
    "benchmark.question-mapping.only-untagged": "Only untagged",
    "benchmark.question-mapping.period": "Period",
    "benchmark.question-mapping.question-scope": "Question scope",
    "benchmark.question-mapping.survey-question": "Survey question",
    "benchmark.question-mapping.survey-questions.title": "Tag library question with survey questions",
    "benchmark.question-mapping.survey-years": "Survey years",
    "benchmark.question-mapping.surveyType.dei": "Diversity, Equity & Inclusion",
    "benchmark.question-mapping.surveyType.engagement": "Engagement",
    "benchmark.question-mapping.surveyType.exit": "Exit",
    "benchmark.question-mapping.surveyType.onboarding": "Onboarding",
    "benchmark.question-mapping.switch-mode": "Switch to Tagging by Survey Question",
    "benchmark.question-mapping.tagged": "Tagged questions",
    "benchmark.question-mapping.tagged-survey-questions": "Tagged survey questions",
    "benchmark.question-mapping.tagged-with-count": "Tagged questions ({{count}})",
    "benchmark.question-mapping.title": "Tagging Survey Questions for Benchmark",
    "benchmark.question-mapping.untagged": "Untagged questions",
    "benchmark.question-mapping.update-mappings": "Save with {{selectedCount}} tagged questions",
    "benchmark.question.indicator-tooltip": "This question is part of WorkTango Benchmarking",
    "benchmark.title": "Benchmark",
    "benchmark.title.attribute": "{{attributeName}} Benchmark",
    "benchmark.title.attribute-value": "{{attributeName}}: {{valueName}}",
    "benchmark.title.same-country": "same-country",
    "benchmark.title.same-industry": "Same industry",
    "benchmark.title.same-region": "Same region",
    "benchmark.title.same-sector": "Same sector",
    "benchmark.title.same-size": "Same size",
    "benchmark.title.top-quartile": "Top quartile",
    "benchmark.tooltip.disabled-option": "WorkTango has not captured this information for your organization. Please reach out to your Customer Success representative for assistance.",
    "benchmark.tooltip.na": "Currently, only questions are being benchmarked",
    "benchmark.tooltip.no-other-values": "There are not enough other organizations with a different {{attributeName}} to compare against.",
    "benchmark.unknown": "unknown",
    "benchmark.value-dropdown.label": "Other {{attributeName}}",
    "benchmark.value-dropdown.placeholder": "Choose {{attributeName}}",
    "boolean.no": "No",
    "boolean.yes": "Yes",
    "bottom.attributes": "Bottom five attributes",
    "bounced.emails.list": "Some employees did not receive an email. Please review the error list below for more details.",
    "btc_sliding_05-07-2018": "Bitcoin",
    "button.add-filters": "Add filters...",
    "button.add-selected": "Add selected",
    "button.addRule": "Add Second Rule",
    "button.analyze": "Analyze",
    "button.apply": "Apply",
    "button.approve-all": "Approve all",
    "button.automate.activate.survey": "Activate Survey",
    "button.automate.deactivate.survey": "Deactivate survey",
    "button.back": "Back",
    "button.back-attribute": "Back to all attributes",
    "button.cancel": "Cancel",
    "button.clone": "Clone",
    "button.close": "Close",
    "button.confirm": "Confirm",
    "button.create": "Create",
    "button.debug": "Debug",
    "button.delete": "Delete",
    "button.download-template": "Download Template",
    "button.edit": "Edit",
    "button.edit-prompt": "Edit Prompt",
    "button.export": "Export",
    "button.filter-results": "Filter results",
    "button.filters": "Filters",
    "button.got-it": "Got it",
    "button.hide": "Hide",
    "button.launch": "Schedule Survey",
    "button.launchNow": "Confirm",
    "button.launchlater": "Cancel",
    "button.leave": "Leave",
    "button.next-step": "Next Step",
    "button.ok": "OK",
    "button.override": "Override",
    "button.previous-step": "Previous Step",
    "button.re-analyze": "Re-analyze",
    "button.remove": "Remove",
    "button.removeRule": "Remove Second Rule",
    "button.reset": "Reset",
    "button.retry-analysis": "Retry Analysis",
    "button.return": "Continue editing",
    "button.return-templates": "Return to Templates",
    "button.save": "Save",
    "button.save-changes": "Save Changes",
    "button.save-prompt": "Save Prompt",
    "button.saveAndClose": "Save and close",
    "button.saveAndSchedule": "Save Changes and Schedule",
    "button.search": "Search",
    "button.select.all.matches": "Select All {{count}} Matches",
    "button.select.all.visible": "Select All Visible",
    "button.send.test": "Send test email...",
    "button.show": "Show",
    "button.start": "Start",
    "button.start-import": "Start Import",
    "button.start-migration": "Start Migration",
    "button.tag.all.matches": "Tag All {{count}} Matches",
    "button.tag.all.visible": "Tag All Visible",
    "button.tooltip.migration-failure": "Please look up the reason for failure in the email that was sent to {{email}}",
    "button.tooltip.pending-for-approval": "Approve migration and mark survey as Completed",
    "button.unselect.all": "Unselect All",
    "button.unselect.visible": "Unselect Visible",
    "button.untag.all.matches": "Untag All {{count}} Matches",
    "button.untag.all.visible": "Untag All Visible",
    "button.update": "Update",
    "button.upload-survey": "Upload survey data",
    "button.yes-remove": "Yes, remove",
    "categories.all": "Select Factor",
    "category.enName": "Factor Name(En)",
    "category.frName": "Factor Name(Fr)",
    "category.name": "Factor Name",
    "change": "Change",
    "clear.content.type": "Clear content type",
    "clibrary.navigation.read": "Read",
    "clibrary.navigation.starred": "Starred",
    "clibrary.navigation.unread": "Unread",
    "close": "Close",
    "coach.end.summary.qestion": "Is there anything specific you'd like me to clarify or delve deeper into regarding this survey?",
    "coach.present.summary.header": "Here is your ai-generated summary for the survey:",
    "colorpicker.title": "Choose color",
    "comment.idea": "Great Idea!",
    "comment.like": "Like",
    "comment.reply": "Reply to this comment",
    "comment.working": "Working on it",
    "comments.attributeFiltersIgnored": "The filters you've applied are not reflected in the comments below.",
    "comments.filter.sentiment": "Filter by sentiment",
    "comments.filter.theme": "Filter by theme",
    "common.approved": "Approved",
    "common.bottom": "Bottom",
    "common.field.isDisabled": "You can't edit this field",
    "common.nameUsed": "Name has already been used!",
    "common.none": "None",
    "common.not-approved": "Not approved",
    "common.notify": "Notify",
    "common.other": "Other",
    "common.select": "Select",
    "common.selected": "selected",
    "common.top": "Top",
    "company.add": "Add Company",
    "company.error.duplicateSalesforceId": "A company with the same Salesforce ID already exists",
    "company.industry.assetIntensive": "Asset-Intensive",
    "company.industry.financialService": "Financial Services",
    "company.industry.healthcare": "Healthcare",
    "company.industry.technology": "Technology",
    "company.region.APAC": "APAC",
    "company.region.Canada": "Canada",
    "company.region.EMEA": "EMEA",
    "company.region.NorthAmerica": "North America",
    "company.region.UnitedStates": "United States",
    "company.sector.private": "Private",
    "company.sector.public": "Public",
    "compare-with": "Compare With",
    "compare.attribute": "Attribute Compare",
    "compare.attributes": "Attribute(s)",
    "compare.dropdown.benchmarks-group": "Benchmarks, doesn't use applied filters",
    "compare.dropdown.current-survey-group": "Current survey(s), doesn't use applied filters",
    "compare.dropdown.different-timeframe": "Different Timeframe",
    "compare.dropdown.other-surveys-group": "Other survey, uses applied filters",
    "compare.none": "None",
    "compare.organization": "Organization Wide",
    "compare.survey": "Survey",
    "compare.timeframe": "Timeframe Compare",
    "compare.to": "Compare to: {{name}}",
    "compare.toSurvey": "Survey Compare",
    "completed": "Completed",
    "contact.us": "Contact Us",
    "continuous-survey.triggers.add-trigger": "Configure new trigger for this survey...",
    "continuous-survey.triggers.configure-automation": "Configure automation",
    "continuous-survey.triggers.no-triggers-subtitle": "There are no active triggers configured for this survey. For automation to work, at least one active trigger is required. ",
    "continuous-survey.triggers.no-triggers-warning": "No active triggers configured",
    "continuous-survey.triggers.trigger-type-disabled-button": "Go to survey automation settings",
    "continuous-survey.triggers.trigger-type-disabled-subtitle": "The system will not be automatically adding new survey candidates to this survey.",
    "continuous-survey.triggers.trigger-type-disabled-warning": "Automation is deactivated",
    "continuous-survey.triggers.view-all": "View triggers for all surveys",
    "conversations.placeholder": "Type a message...",
    "courier.general.click.here": "Reset my password",
    "courier.password.reset.email": "someone has requested a link to reset your password for the WorkTango platform.",
    "create.reminder.button": "Create a new reminder...",
    "createSurvey.logicEditor": "Logic Editor",
    "createSurvey.questionEditor": "Question Editor",
    "created": "Created",
    "created.by": "Created by",
    "cs-cz": "Czech",
    "da-dk": "Danish",
    "date.operator.greater": "greater than or equal to",
    "date.operator.less": "less than or equal to",
    "date.unit.day": "day(s)",
    "date.unit.month": "month(s)",
    "date.unit.year": "year(s)",
    "dateStatus0": "Created:",
    "dateStatus1": "Scheduled:",
    "dateStatus2": "Expires:",
    "dateStatus3": "Completed on:",
    "de-de": "German",
    "deactivated": "Deactivated",
    "debug.header": "Debug",
    "default": "default",
    "detractor.2": "Detractor",
    "disabled": "Inactive",
    "dmin.survey.build.add-recipient.title_one": "Add {{count}} New Recipient?",
    "doNotContact.add.success": "Employee successfully added to list.",
    "doNotContact.adding-reason": "Reason for adding",
    "doNotContact.adding-reason.placeholder": "Enter a reason why this employee or employees is being added",
    "doNotContact.automaticEmailTriggers.tab": "AUTOMATIC EMAIL TRIGGERS",
    "doNotContact.button.addEmployee": "Add employee to the list",
    "doNotContact.dialog.add.noEmployees": "There are no employees matching your filters.",
    "doNotContact.dialog.add.title": "Select employees to add",
    "doNotContact.dialog.delete.message1": "Removing a person from this list means that they are no longer ignored in automated survey invitations. ",
    "doNotContact.dialog.delete.message2": "In case you’re not the person who initially placed {{name}} on the list, the system will also send a notification to the user who did.",
    "doNotContact.dialog.delete.message3": "Are you sure you want to remove {{name}} from the list?",
    "doNotContact.dialog.delete.title": "Remove {{name}} from the list?",
    "doNotContact.filterEmployee": "Filter employees",
    "doNotContact.page.title": "Do Not Contact List",
    "doNotContact.reason.required": "This field cannot be empty",
    "doNotContact.remove.success": "Employee successfully removed from list.",
    "doNotContact.selectedEmployees.required": "You need to select at least one employee from the list.",
    "doNotContact.smsOptOuts.addEmployee": "Add employee to SMS opt-out list",
    "doNotContact.smsOptOuts.addedBySystem": "SYSTEM",
    "doNotContact.smsOptOuts.description": "Following employees will not be reminded or invited via SMS to any surveys in the future.",
    "doNotContact.smsOptOuts.remove.message1": "Removing a person from this list means that they are no longer ignored in SMS survey invitations and reminders.",
    "doNotContact.smsOptOuts.tab": "SMS OPT-OUTS",
    "doNotContact.table.addedAtTimeUTC": "Added to list",
    "doNotContact.table.addedByUserName": "Added by",
    "doNotContact.table.email": "Email",
    "doNotContact.table.name": "Employee name",
    "doNotContact.table.noData": "There are no employees matching your filters.",
    "doNotContact.table.reason": "Reason",
    "draft": "Draft",
    "el-gr": "Greek",
    "email": "Email",
    "email.account.locked.body.if.you.did.not.attempt": "If you were not the one attempting to login please include this information in the request to our support team.",
    "email.account.locked.body.please.reach.out": "Please reset your password to unlock your account.",
    "email.account.locked.body.someone.have.attempted": "Someone has attempted to login to WorkTango with this email address and has failed multiple times.",
    "email.account.locked.reset.password": "Reset password",
    "email.account.locked.subject": "WorkTango account locked",
    "email.activate.account.btn": "Activate your account",
    "email.anon.convo.employee.have.replied": "an employee has replied to an anonymous conversation that you are a part of. As per WorkTango’s Employee Promise, your response is confidential.",
    "employee.addNewEmployee": "Add new employee",
    "employee.duplicatedEmployeeId": "There are multiple rows using the same employeeId: {{employeeId}}",
    "employee.export.exportEmployees": "Export Employees",
    "employee.export.loading": "We are processing your request, please wait...",
    "employee.import.activationWarning.agreementMessage": "I understand that 1 new user will be activated",
    "employee.import.activationWarning.agreementMessage.plural": "I understand that {{count}} new users will be activated",
    "employee.import.activationWarning.description": "Following employees will be granted access to the system as per their role listed in brackets if you proceed with this import:",
    "employee.import.activationWarning.title": "Activation warning",
    "employee.import.email.failed.error.label": "Error details:",
    "employee.import.email.failed.message": "Your employee import for {{companyName}} could not be completed. No changes were made to your employee data while processing {{fileName}}.",
    "employee.import.email.failed.next.steps": "Correct the problem in {{fileName}} and start the import again.",
    "employee.import.email.failed.subject": "Employee import failed",
    "employee.import.email.succeeded.message": "Your employee import for {{companyName}} has finished processing {{fileName}}. Your employee data is now up to date.",
    "employee.import.email.succeeded.subject": "Employee import completed",
    "employee.import.error.attributeTypeErrors": "Incorrect Attribute Value Type",
    "employee.import.error.customPermissionsRows": "\"Custom Permissions\" cannot be set (row {{rows}}). Custom Permissions can only be added in the platform, only granting named roles is supported in the file.",
    "employee.import.error.duplicateUniqueValues": "Duplicate Unique Value",
    "employee.import.error.fileValidation": "Please fix the following errors in your file and try again",
    "employee.import.error.fileValidationDescription": "Please correct them and upload a new file.",
    "employee.import.error.fileValidationTitle": "Uploaded file has issues.",
    "employee.import.error.invalidType": "employee '{{employeeId}}' has incorrect value type for {{attrType}} field '{{attrName}}'",
    "employee.import.error.invitingDisabledEmployee": "You cannot both invite a new user and disable their access. Either clear the $SurveyRole value or set Enabled to 'Yes' in row(s) {{rows}}",
    "employee.import.error.missingField": "employee '{{employeeId}}' is missing required field '{{attrName}}'",
    "employee.import.error.missingRequiredErrors": "Missing Required Field",
    "employee.import.error.modifiedEmployeeId": "ID of {{employeeName}} changed from {{oldEmployeeId}} to {{newEmployeeId}}",
    "employee.import.error.modifiedEmployeeIdErrors": "Modified Employee IDs (should NOT change here)",
    "employee.import.error.noHeaders": "Missing Attribute Header",
    "employee.import.error.unableToImport": "Unable to import employees",
    "employee.import.error.unableToReadFile": "Unable to read file. Try a different file, or fix issue with selected file.",
    "employee.import.error.unknownAttributeNames": "Unknown Attribute Name",
    "employee.import.error.unknownRoleNamesRows": "Unknown role name provided (row {{rows}}). Make sure that the role name provided in the file is identical to the one configured in the platform.",
    "employee.import.error.unsupportedLangs": "Unsupported Language",
    "employee.import.error.userMissingEmailRows": "User missing email (row {{rows}}). Make sure that all users (employees with roles) have an email address.",
    "employee.import.history.column.date": "Upload date",
    "employee.import.history.column.uploader": "Uploader",
    "employee.import.history.dialog.date": "Import date",
    "employee.import.history.dialog.dateOriginFile": "Import date, origin, and original filename",
    "employee.import.history.dialog.dateOriginFileValue": "{{date}} by {{origin}} ({{fileName}})",
    "employee.import.history.dialog.dateOriginValue": "{{date}} by {{origin}}",
    "employee.import.history.dialog.errors": "Error details",
    "employee.import.history.dialog.errorsCount": "1 error",
    "employee.import.history.dialog.errorsCount.plural": "{{count}} errors",
    "employee.import.history.dialog.issueRow": "Row {{rowNumber}}: {{message}}",
    "employee.import.history.dialog.issues": "Import errors and warnings",
    "employee.import.history.dialog.loadError": "There was an error loading import details. Please try again.",
    "employee.import.history.dialog.notFound": "This import could not be found.",
    "employee.import.history.dialog.title": "Import details",
    "employee.import.history.dialog.warningsCount": "1 warning",
    "employee.import.history.dialog.warningsCount.plural": "{{count}} warnings",
    "employee.import.history.empty": "No imports yet.",
    "employee.import.history.loadError": "There was an error loading import history. Please try again.",
    "employee.import.history.status.error": "Error",
    "employee.import.history.status.processing": "Processing",
    "employee.import.history.title": "Import history",
    "employee.import.history.viewDetails": "View Details...",
    "employee.import.importEmployees": "Import Employees",
    "employee.import.importFile": "Import File",
    "employee.import.importType": "Import Type",
    "employee.import.instructions": "This action will update employee data based on the import file content and your import type setting.",
    "employee.import.instructions.generated-file": "Please use the <0>generated sample file</0> for proper formatting.",
    "employee.import.is-valid": "Uploaded file has no issues.",
    "employee.import.override": "This action will overwrite the current employee file and replace it with the file being uploaded. NOTE: Any employee not on the new list will be marked as Inactive",
    "employee.import.override.description": "In addition to adding new and updating existing, employees not listed in the import file will be deactivated",
    "employee.import.scheduled.message": "We'll email you when your employee file has finished importing.",
    "employee.import.scheduled.title": "Import started",
    "employee.import.selectFile": "Select a File (.xlsx or .csv)",
    "employee.import.success": "Employee data imported successfully",
    "employee.import.title": "Import Employee Data",
    "employee.import.update": "This action will update existing file with any new information on the file being uploaded",
    "employee.import.update.description": "Employee data in the file will be used to create new employees and update existing employee data",
    "employee.import.validating-file": "Checking for file issues...",
    "employee.import.warning.accept-deactivated.employees": "I understand that $t(employees, {\"count\": {{employees}} }) will be deactivated",
    "employee.import.warning.accept-deactivated.users": "I understand that $t(users, {\"count\": {{users}} }) will be deactivated",
    "employee.import.warning.accept-deactivated.users-and-employees": "I understand that $t(users, {\"count\": {{users}} }) and $t(employees, {\"count\": {{employees}} }) will be deactivated",
    "employee.import.warning.deactivatedEmployees": "Following employees will be deactivated if you proceed with this import:",
    "employee.import.warning.deactivatedUsers": "Following users will be deactivated if you proceed with this import:",
    "employee.import.warning.title": "Deactivation warning",
    "employee.list.lastUpdated": "Last updated: {{date}}",
    "employee.update-ids.description": "This action will irreversibly update Employee ID for everyone included in the file.",
    "employee.update-ids.employee-id": "Employee Id",
    "employee.update-ids.error.blankCurrentIds": "Missing current IDs",
    "employee.update-ids.error.blankNewIds": "Missing new IDs",
    "employee.update-ids.error.duplicatedCurrentIds": "Duplicated current IDs",
    "employee.update-ids.error.duplicatedNewIds": "Duplicated new IDs",
    "employee.update-ids.error.empty-new-id": "New employee id can't be empty",
    "employee.update-ids.error.file-validation": "Upload file has issues, please correct them and upload again",
    "employee.update-ids.error.invalidCurrentIds": "Current IDs don't exist",
    "employee.update-ids.error.occupied-new-id": "New employee id is already taken. Please enter a unique one.",
    "employee.update-ids.error.occupiedNewIds": "New IDs already occupied",
    "employee.update-ids.error.row-no": "Row No",
    "employee.update-ids.error.unable-update": "Unable to update company employee ID",
    "employee.update-ids.individual.title": "Update Employee ID",
    "employee.update-ids.sampleFile1": "Please use the",
    "employee.update-ids.sampleFile2": "for proper formatting.",
    "employee.update-ids.success": "Employee IDs updated successfully.",
    "employee.update-ids.success-completed": "Employee IDs updated successfully.",
    "employee.update-ids.title": "Employee ID Bulk Update",
    "employee.update-ids.updating": "Updating Employee IDs",
    "employee.update-ids.upload-file": "Upload File",
    "employee.upload-ids.validate.loading": "Checking for file issues",
    "employee.upload-ids.validate.pass": "Uploaded file has no issue.",
    "employee.upload.employeeData": "Employee data",
    "employee.upload.mismatch": "There are mismatched field(s) in your file",
    "employee.upload.uniqueConflict": "Employee: {{ firstEmployee }} and employee: {{ lastEmployee }} are using the same value: {{ value }} for attribute: {{ name }}",
    "employee.upload.updateEmployeeIds": "Bulk Employee ID update",
    "employees.accessChange.attributeFrom": "{{attribute}} changing from",
    "employees.accessChange.attributeTo": "to",
    "employees.accessChange.begin": "Employees whose data access will change:",
    "employees.accessChange.desc": "The following employee(s) are also users and have access to survey data based on their employee attributes. Continuing with this change will change their survey data access. Do you want to continue?",
    "employees.accessChange.title": "Warning! Survey data access will change for some users",
    "employees.export.success": "Employees exported to file '{{filename}}'.",
    "employees_one": "{{count}} employee",
    "employees_other": "{{count}} employees",
    "en-ca": "English (CA)",
    "en-us": "English (US)",
    "entities.table.entity": "Entity",
    "entities.table.frequency": "Frequency",
    "entities.table.sentiment": "Sentiment",
    "entities.table.type": "Type",
    "error.create.roleName.required": "Role name is required",
    "error.invite.all.emails.valid": "all emails must be valid",
    "error.invite.at.least.one.email": "need at least one email address",
    "error.invite.at.least.one.survey.type.permission": "require at least one survey type permission",
    "error.invite.from.required": "from name is required",
    "error.invite.include.all.compare.attributes.in.filter.attributes.list": "Add the attributes on \"{{compareAttributesHeader}}\" list that are not on \"{{filterAttributesHeader}}\" list.",
    "error.invite.language.required": "language is required",
    "error.invite.oops": "Oops, looks like we're missing something",
    "error.invite.please.check.validations": "Please check the following validations:",
    "error.lockedOut": "You have exceeded the maximum allowed number of login attempts. To unlock your account, reset your password.",
    "error.msg.invalid.employee": "Invalid employee id",
    "error.msg.you.have.exceeded.max.login.attempts": "You have exceeded the maximum allowed number of login attempts. To unlock your account, reset your password by clicking the \"Forgot password?\" link below.",
    "error.no.employee.matching.hierarchy.user": "In order to invite users with hierarchy-based access or attribute-based access, they need to be listed as an employee",
    "error.roleName.duplicated": "Role name already exists!",
    "error.somethingWentWrong": "Something went wrong",
    "error.validationError": "Validation Error",
    "errorBoundary.errorPreDescription": "Error details that can help our technicians diagnose the issue:",
    "errorBoundary.headImageAltText": "A server is on the right side while on the centre is the unplugged outlet.",
    "errorBoundary.resetButton": "Reload this page",
    "errorBoundary.subtitle": "The system encountered an unexpected error. Please try reloading the page.",
    "errorBoundary.title": "Whoops!",
    "errors.tokenExpired": "please login",
    "es-es": "Spanish",
    "export.all": "All Data",
    "export.attributeType": "Attribute Type",
    "export.attributesSelected": "Attributes Selected:",
    "export.comment": "Comment",
    "export.compareTo": "Compare To:",
    "export.favourable": "Favourable",
    "export.filterSelected": "Filter Selected:",
    "export.header": "Export",
    "export.neutral": "Neutral",
    "export.outof": "Out of",
    "export.overallResponseRate": "Overall Response Rates",
    "export.qualitative": "Qualitative Data",
    "export.quantitative": "Quantitative Data",
    "export.question": "Question:",
    "export.surveySelected": "Survey Selected:",
    "export.themes": "AI Themes",
    "export.title.timeframe-selected": "Timeframe Selected:",
    "export.unfavourable": "Unfavourable",
    "exportMenu.errorDialog.message": "Failed to generate summary export.",
    "exportMenu.export": "Export",
    "exportMenu.loadingDialog.message": "We're creating your export now. It should start downloading within the next minute.",
    "exportMenu.loadingDialog.title": "Your export will be ready shortly.",
    "factor": "Factor",
    "factor.score": "Factor Score",
    "factors": "Factors",
    "factors.filter.prompt": "Select a factor(s)",
    "factors.questions": "Factors Question",
    "favorable.button.text": "FAV",
    "feedback.email.subject.anon.reaction": "Your completely confidential feedback has an acknowledgment.",
    "fi-fi": "Finnish",
    "field.isRequired": "{{field}} is a required field.",
    "fieldType.boolean": "Yes/No",
    "fieldType.date": "Date",
    "fieldType.email": "Email",
    "fieldType.number": "Number",
    "fieldType.string": "Text",
    "fieldType.time": "Time",
    "filter.attributes.main": "Select attribute",
    "filter.attributes.values": "Select attribute value(s)",
    "filter.by.factors": "Filter by Factors",
    "filter.byAttribute": "Filter by Attribute",
    "filter.date.startMessage": "Show all recipients with a",
    "filter.date.title": "Filter by Start Date",
    "filter.dateRange.clear": "Clear date range",
    "filter.dateRange.title": "Select date range",
    "filter.filterBy": "Filter by",
    "filter.message": "Search a message...",
    "filter.question": "Filter by Question",
    "fixed_eyes": "Eyes",
    "fixed_faces_1": "Faces 1",
    "fixed_faces_2": "Faces 2",
    "fixed_flowers": "Flowers",
    "fixed_gas_tank": "Gas Tank",
    "fixed_generation": "Generation",
    "fixed_glasses_of_water": "Glasses of Water",
    "fixed_growing_wheels": "Wheels Progression",
    "fixed_hands": "Hands",
    "fixed_hearts_gradient": "Hearts (Gradient)",
    "fixed_hurdles": "Hurdles",
    "fixed_ice_cream_emoji": "Ice Cream Emoji",
    "fixed_mad_happy_emoji": "Mad-Happy Emoji",
    "fixed_magnifying_glass": "Magnifying Glass",
    "fixed_mood_weather": "Mood Weather",
    "fixed_office": "Office",
    "fixed_overwhelmed_happy_emoji": "Overwhelmed-Happy Emoji",
    "fixed_poo_emoji": "Poo Emoji",
    "fixed_rockets": "Rockets",
    "fixed_sad_happy_emoji": "Sad-Happy Emoji",
    "fixed_stairs": "Stairs",
    "fixed_teal_rose": "Blooming Rose",
    "fixed_technology": "Technology",
    "fixed_thumbs_rotating": "Rotating Thumbs",
    "fixed_trophies": "Trophies",
    "fixed_type_of_work": "Type of Work",
    "fixed_workplace_flexibility": "Workplace Flexibility",
    "forgot.password.dialog.description": "Your password reset link is on its way!",
    "forgot.password.dialog.title": "Check your inbox!",
    "forgot.password.instruction": "Don’t worry; it happens to the best of us. Add your email below, and we’ll send you a link to reset your password.",
    "form.dependsOn": "Field {{label}} is required",
    "form.exit": "Close",
    "form.fileError": "Please check the following field(s) in your file",
    "form.fileSelected": "File Selected:",
    "form.invalid": "Oops, please check your input(s)!",
    "form.invalidAttribute": "Attribute '{{name}}' is not valid",
    "form.isBoolean": "This field need to be True/False",
    "form.isDate": "This field need to be a YYYY-MM-DD",
    "form.isEmail": "Please enter a valid email address",
    "form.isNotA": "'{{value}}' is not a {{type}}",
    "form.isNumber": "This field need to be a Number",
    "form.isRequired": "This field is required",
    "form.isUnique": "This field needs to be unique",
    "form.row": "Row",
    "fr-ca": "French (CA)",
    "fr-fr": "French (FR)",
    "gemAI.dialog.title": "Generative AI prompt and response",
    "genAI.button.awaiting-response": "Awaiting Response from AI",
    "genAI.button.export-ai-data": "Start exporting AI data",
    "genAI.button.send-prompt": "Re-send Prompt and Save New Response",
    "genAI.commentAnalysis.deleteDialog.confirmButton": "Yes, delete",
    "genAI.commentAnalysis.deleteDialog.confirmText": "Are you sure you want to delete this analysis?",
    "genAI.commentAnalysis.deleteDialog.descriptionText": "This action will permanently delete the AI generated <0>comment summary</0>, and allow you to generate a new one. Please note that the new comment summary might differ from the original one, either stylistically or in its content. This is especially true in cases where the AI prompt or AI algorithm have been updated between now and the last time it was generated.",
    "genAI.commentAnalysis.deleteDialog.error": "Error while deleting AI analysis. Try again.",
    "genAI.commentAnalysis.deleteDialog.success": "AI analysis deleted successfully.",
    "genAI.commentAnalysis.deleteDialog.title": "Delete AI analysis",
    "genAI.comments.analysis": "AI Analysis",
    "genAI.comments.analysis-available": "AI Analysis is available",
    "genAI.comments.analysis-negatives": "The negatives",
    "genAI.comments.analysis-next-steps": "Recommended Actions",
    "genAI.comments.analysis-not-performed": "Ask AI to interpret results?",
    "genAI.comments.analysis-positives": "The positives",
    "genAI.comments.analysis-summary": "In a nutshell",
    "genAI.comments.analyzing": "AI is analyzing results...",
    "genAI.comments.continuous-survey.analyze": "Ask AI to interpret results for this timeframe?",
    "genAI.comments.continuous-survey.failed-load": "There was an issue processing your request. Ask AI to retry interpreting results for this timeframe?",
    "genAI.comments.failed-load": "There was an issue processing your request. Ask AI to retry interpreting results?",
    "genAI.debug-mode": "AI Debug Mode",
    "genAI.dialog.context-label": "Context used to prime the AI",
    "genAI.dialog.prompt-label": "Prompt used to generate response",
    "genAI.dialog.response-label": "Raw AI Response",
    "genAI.dialog.sentiment-label": "Parsed Sentiment",
    "genAI.dialog.theme-label": "Parsed Key Theme(s)",
    "genAI.export.AI-generated-data": "AI-generated data",
    "genAI.export.AI-report-dialog.title": "Download AI-generated data",
    "genAI.export.ai-report.text1": "This action will initiate gathering of all AI-generated data for this survey and compile it into an Excel file. The file will be made available for <0>one time download</0> via email link that will be sent to the following address:",
    "genAI.export.ai-report.text2": "Please make sure the above email address is correct before requesting the export to start.",
    "genAI.label.find-in-comments": "Find in comments",
    "genAI.not-available": "Not available",
    "genAI.question.analysis-generated": "AI analysis generated",
    "genAI.question.analysis-not-performed": "AI analysis not performed",
    "genAI.surveys.analysis-areas-of-opportunity": "Areas of Opportunity",
    "genAI.surveys.analysis-areas-to-watch": "Areas to Watch",
    "genAI.surveys.analysis-overall-summary": "Overall Short Summary of Findings",
    "genAI.surveys.analysis-participation-rate": "Participation Rate",
    "genAI.surveys.analysis-qualitative-feedback": "Summary of Qualitative Feedback",
    "genAI.surveys.analysis-recommended-actions": "Recommended Actions",
    "genAI.surveys.analysis-strengths": "Strengths",
    "genAI.title.key-theme": "Key Theme",
    "genAi.comments.error.rate-limit": "You have encountered our rate limit for this AI functionality. The current limit allows for a maximum of 20 summaries within a 10-minute period.\nAccess will be restored within the next 10 minutes. Thank you for your patience.",
    "genAi.comments.translationNotification": "Please note the following summary was translated from English.",
    "genai.": "",
    "genai.analysis-type.comment-analysis": "Comment Sentiment Analysis",
    "genai.analysis-type.comments-summary": "Comments Summary",
    "genai.analysis-type.rating-question-summary": "Rating Question Summary",
    "genai.analysis-type.theme-association": "Theme Association",
    "genai.analysis-type.theme-extraction": "Theme Extraction",
    "genai.button.config-prompts": "Configure Prompts",
    "genai.prompt-custom.token-label": "Available tokens:",
    "general.clearAll": "Clear All",
    "general.here": "here",
    "global.error.500": "Oops, something went wrong! ",
    "graph.average": "Average",
    "graph.detractors": "Detractors",
    "graph.favorable": "Favourable",
    "graph.neutral": "Neutral",
    "graph.passives": "Passives",
    "graph.promoters": "Promoters",
    "graph.respondents": "{{answered}}  out of {{total}} people responded",
    "graph.unfavorable": "Unfavourable",
    "group.delete": "Delete",
    "has.suggestions.description": "Here are our recommended actions and learnings based on your survey results.",
    "header.actionContent": "Action Content",
    "header.help": "Help",
    "header.learning-content": "Learning Content",
    "header.logout": "Logout",
    "header.profile": "Profile",
    "header.signin": "Sign In",
    "header.surveyTemplates": "Templates",
    "header.switch": "Switch Company",
    "heatmap.allAnonymized.tooltip": "The \"All Anonymized\" consists of a maximum of {{ fully }} fully anonymous employee responses and {{ partial }} partially anonymized questions due to attribute conditions or question logic. Utilize the Article to learn more.",
    "heatmap.compare.empty": "No data available shown because there was no {{ filter }} in {{ compare }}",
    "heatmap.header": "Heatmap",
    "heatmap.hide.empty.columns": "Hide empty columns",
    "heatmap.legend.highest": "Highest",
    "heatmap.legend.least.favorable": "Lowest Favourable",
    "heatmap.legend.lowest": "Lowest",
    "heatmap.legend.most.favorable": "Highest Favourable",
    "heatmap.legend.negative": "Unfavourable",
    "heatmap.legend.positive": "Favourable",
    "heatmap.legend.text": "data reflects min and max values for your survey's responses",
    "heatmap.overall": "overall",
    "heatmap.responses": "Number of Responses",
    "heatmap.score": "Score",
    "heatmap.show.categories": "Factors",
    "heatmap.show.questions": "Questions",
    "help.email.header": "Email Us",
    "help.email.message": "Send us an email at",
    "help.guides.header": "User Guide",
    "help.guides.linkText": "Click here for our User Guide",
    "help.guides.message": "Read our user guide covering all sections of this platform",
    "help.header": "Help",
    "help.intercom.header": "Live Chat",
    "help.intercom.message": "Chat with us during office hours. Click on the Speech bubble on the bottom left (if you don't see it, please try refreshing your browser).",
    "help.roadmap.title": "Our current roadmap",
    "hi-in": "Hindi",
    "hide": "Hide",
    "hierarchy.turnedOffReason": "WorkTango Hierarchy Heatmap will be temporarily unavailable starting Tuesday, November 25, 2025 at 5:00 PM EST as we roll out updates. Service will resume immediately once the updates are complete. We apologize for any inconvenience.",
    "highest.label": "Highest",
    "hour": "hour",
    "hours": "hours",
    "hu-hu": "Hungarian",
    "id-id": "Indonesian",
    "image.aspect": "image aspect ratio should be approximately {{x}}:{{y}}",
    "importing": "Importing...",
    "in.progress": "In progress",
    "inbox.header": "Conversations",
    "insights.bad": "THE BAD",
    "insights.explainertext.bad": "Below are areas that may need improvement.",
    "insights.explainertext.good": "You're doing great in these areas, and your employees are noticing!",
    "insights.explainertext.ugly": "Immediate attention is required in these areas.",
    "insights.good": "THE GOOD",
    "insights.ugly": "THE UGLY",
    "invalid.email.format": "Email is in the wrong format, please try again",
    "invite.new": "Invite New",
    "invites.pending.delete": "Are you sure you want to delete these pending invitations?",
    "invites.pending.delete.confirm": "After deleting the invitation, the users will not be able to log into WorkTango. You can always re-invite these users back to WorkTango in the future.",
    "is.platform.user.export.column.name": "Is User",
    "it-it": "Italian",
    "jp-jp": "Japanese",
    "keyFactor": "Key Factor",
    "keyFactors": "Key Factors",
    "keyQuestions": "Key Factor Questions",
    "ko-kr": "Korean (South Korea)",
    "kw.custom.access.not.set.up.check.back.later": "Please check back later.",
    "kw.custom.access.not.set.up.yet": "Your access is still being set up by your administrator, and you can contact them for a status update.",
    "kw.permission.setup.in.progress": "Permission setup in progress",
    "label.invite.users": "Invite New Users",
    "label.no.filters": "No results found for the filters selected. Try a different set of filters.",
    "language": "Language",
    "language.code.desc": "Please use the corresponding WorkTango language code for the Language column when importing new employees",
    "languageCode": "Language Codes",
    "layout.cardview": "Card View",
    "layout.listview": "List View",
    "learning": "Learning",
    "less.than.an.hour": "less than an hour",
    "lifecycle.survey.email.access.outbox": "Go to the Outbox",
    "lifecycle.survey.email.access.outbox.weekly.digest": "See who’s getting invited soon",
    "lifecycle.survey.email.digest.explainer": "The following employees were automatically added to a WorkTango survey",
    "lifecycle.survey.email.digest.subject": "Automated survey invitation report for the past week",
    "lifecycle.survey.outbox.candidate.was.invited": "%employeeName%, was invited on %targetInvitationDate% to %surveyName%",
    "lifecycle.survey.outbox.candidate.will.be.invited": "%employeeName%, to be invited on %targetInvitationDate% for %surveyName%",
    "lifecycle.survey.outbox.employees.added.exit": "The following employees were identified as candidates for an exit survey, and have been placed in the Outbox. You can review the whole list by following the link below.",
    "lifecycle.survey.outbox.employees.added.onboarding": "The following employees were identified as candidates for an onboarding survey, and have been placed in the Outbox. You can review the whole list by following the link below.",
    "lifecycle.survey.outbox.updated.header.exit": "Exit survey Outbox was updated",
    "lifecycle.survey.outbox.updated.header.onboarding": "Onboarding survey Outbox was updated",
    "lifecycle.survey.outbox.updated.subject.exit": "Exit Outbox updated",
    "lifecycle.survey.outbox.updated.subject.onboarding": "Onboarding Outbox updated",
    "lifecycle.survey.weekly.digest.email.header": "Weekly lifecycle survey digest",
    "loading": "Loading... Please wait",
    "login.error": "Invalid username or password provided",
    "login.expired.desc": "Please log in again to access WorkTango.",
    "login.expired.title": "Your session has expired",
    "login.improve.question": "Looking to improve your organization’s engagement?",
    "login.instruction.email": "Enter your email to continue",
    "login.instruction.password": "Enter your password to sign in",
    "login.migrated.desc.first": "Please use",
    "login.migrated.desc.last": "to access WorkTango.",
    "login.migrated.success": "Great news! Your organization is now on the new WorkTango platform!",
    "login.sso.failed.desc": "Sign-in through your company's SSO didn't complete. Please contact your IT admin or WorkTango support and share this reference: {{reference}}",
    "lowest.label": "Lowest",
    "mailing-list.automatic-invitations": "Automatic invitations",
    "mailing-list.automatic-invitations.add-not-contact.modal.confirm-button": "Add to the list",
    "mailing-list.automatic-invitations.add-not-contact.modal.confirm-label": "Reason for adding",
    "mailing-list.automatic-invitations.add-not-contact.modal.confirm-placeholder": "Enter a reason why this employee is being added",
    "mailing-list.automatic-invitations.add-not-contact.modal.description": "Adding a person to this list means that they are no longer a part of any automated survey invitations, but they can still be manually invited to surveys.",
    "mailing-list.automatic-invitations.add-not-contact.modal.description2": "You or another admin with access will be able to reverse this action by access the list and removing them from it at a later point, if needed. A reason for adding will be listed.",
    "mailing-list.automatic-invitations.add-not-contact.modal.title": "Add {{user}} to the Do Not Contact list?",
    "mailing-list.automatic-invitations.approve-all.modal.confirm-button": "Yes, approve all",
    "mailing-list.automatic-invitations.approve-all.modal.description": "This action will approve sending invitation to all candidates on their individual invitation date.",
    "mailing-list.automatic-invitations.approve-all.modal.description2": "Are you sure you want to approve these invitations?",
    "mailing-list.automatic-invitations.approve-all.modal.title": "Approve 1 candidate?",
    "mailing-list.automatic-invitations.approve-all.modal.title-plural": "Approve {{count}} candidates?",
    "mailing-list.automatic-invitations.bulk-actions": "Bulk Actions",
    "mailing-list.automatic-invitations.bulk-actions-with-count": "Bulk Actions ({{count}} Selected)",
    "mailing-list.automatic-invitations.bulk-actions.disabled": "Please first select candidates you wish to perform bulk actions for",
    "mailing-list.automatic-invitations.bulk-add-not-contact.modal.title": "Add {{count}} users to the Do Not Contact list?",
    "mailing-list.automatic-invitations.button.add-to-not-contact": "Add to \"Do not contact\" list",
    "mailing-list.automatic-invitations.button.approve": "Approve",
    "mailing-list.automatic-invitations.button.approve-and-invite": "Approve and invite immediately",
    "mailing-list.automatic-invitations.button.bulk-approve": "Approve selected",
    "mailing-list.automatic-invitations.button.bulk-approve-and-invite": "Approved selected and invite immediately ",
    "mailing-list.automatic-invitations.button.bulk-remove": "Remove from the list",
    "mailing-list.automatic-invitations.button.invite": "Invite immediately",
    "mailing-list.automatic-invitations.button.remove": "Remove from the list",
    "mailing-list.automatic-invitations.button.undo-approval": "Undo approval",
    "mailing-list.automatic-invitations.column.addedToList": "Added to list",
    "mailing-list.automatic-invitations.column.candidateName": "Candidate name",
    "mailing-list.automatic-invitations.column.exitDate": "Exit date",
    "mailing-list.automatic-invitations.column.startDate": "Start date",
    "mailing-list.automatic-invitations.column.status": "Status",
    "mailing-list.automatic-invitations.column.surveyName": "Survey name",
    "mailing-list.automatic-invitations.column.targetInvitationDate": "Target invitation date",
    "mailing-list.automatic-invitations.onboarding-survey.description": "The system identifies the following employees to be invited to complete their survey on their targeted date, and this list is automatically refreshed daily by 9 a.m. EST",
    "mailing-list.automatic-invitations.onboarding-survey.description2": "Please review the list and remove anyone who you do not want receiving an invitation, or move them to the \"Do not contact\" list if you wish to postpone the invitation indefinitely.",
    "mailing-list.automatic-invitations.onboarding-survey.filter-candidates": "Filter candidates",
    "mailing-list.automatic-invitations.onboarding-survey.filter-surveys": "Filter surveys",
    "mailing-list.automatic-invitations.onboarding-survey.title": "Survey candidates",
    "mailing-list.automatic-invitations.snackbar.add-to-not-contact": "Person added to Do Not Contact list successfully",
    "mailing-list.automatic-invitations.snackbar.approve": "Status updated successfully",
    "mailing-list.automatic-invitations.snackbar.approve-all": "Invitations approved successfully",
    "mailing-list.automatic-invitations.snackbar.error": "There was an issue adding this person to the survey. Please refresh the screen and try again",
    "mailing-list.automatic-invitations.snackbar.invite": "Invitation sent successfully",
    "mailing-list.automatic-invitations.snackbar.remove": "Person removed successfully",
    "mailing-list.automatic-invitations.table.no-data": "There are no candidates matching your filters.",
    "mailing-list.automatic-invitations.tooltip.approved": "You have opted to not approve invitations manually, but have them go automatically as soon as the next day after employee being added.  If you wish to change this setting, go to the Company Survey Automation settings.",
    "mailing-list.automatic-invitations.trigger-type.exit": "Only Exit surveys",
    "mailing-list.automatic-invitations.trigger-type.onboarding": "Only Onboarding surveys",
    "mailing-list.blocked-recipients": "Blocked recipients",
    "mailing-list.do-not-contact": "Do not contact",
    "mailing-list.title": "Mailing list management",
    "message.deleteSurveyWarning": "Are you sure you want to delete this survey?",
    "message.stopSurveyWarning": "Are you sure you would like to cancel sending out this survey?",
    "minute": "minute",
    "minutes": "minutes",
    "month": "Month(s)",
    "ms-my": "Malay (Latin)",
    "my-mm": "Burmese",
    "nav.leave.surveys.and.insights": "Leave Surveys & Insights",
    "nav.sidebar.title.surveys.and.insights": "Surveys & Insights",
    "nb-no": "Norwegian Bokmål",
    "next": "Next",
    "nl-nl": "Dutch",
    "no.base.survey.type": "Unknown",
    "no.common.questions": "There are no common questions in the surveys selected.",
    "no.conversations": "There are no conversations at the moment.",
    "no.employee": "No employee found",
    "no.libraryActions": "There are no library actions.",
    "no.reminders": "There are currently no reminders scheduled for this survey",
    "no.reponseRate.text": "There are no responses yet or not enough based on your confidentiality threshold.  Please check back later.",
    "no.results.filter": "No results for the selected filters",
    "no.suggestions.description": "Sorry, we don’t have any recommended actions for the survey(s) and/or filter(s) you’re viewing.",
    "no.survey.instructions": "Please adjust your data set to analyze your results.",
    "no.survey.text": "Select a survey type",
    "no.surveyData.text": "There is no quantitative data for your selected survey(s) or not enough responses based on your confidentiality threshold. Please check back later.",
    "no.trend.text": "Select more than one survey to view trend results.",
    "noAttributeValues": "No values found for this attribute",
    "noCanvasSupport": "Your browser does not support the canvas element. Bar Chart cannot be displayed.",
    "note.survey.question.active.between": "Note: This question was active {{added-date}} to {{discontinued-date}}",
    "note.survey.question.added": "Note: This question was first introduced on {{added-date}}",
    "note.survey.question.discontinued": "Note: This question was discontinued on {{discontinued-date}}",
    "notice.leave.title": "Are you sure you want to leave?",
    "notifications.current.password.incorrect": "Current password supplied is incorrect.",
    "notifications.message.actionCreated": "Action successfully created",
    "notifications.message.actionRemoved": "Action successfully removed",
    "notifications.message.actionUpdated": "Action successfully updated",
    "notifications.message.categoryCreated": "Factor created successfully",
    "notifications.message.categoryRemoved": "Factor removed successfully",
    "notifications.message.categoryUpdated": "Factor updated successfully",
    "notifications.message.companyDeleted": "The company and related data have been deleted!",
    "notifications.message.companyUpdated": "Company updated successfully",
    "notifications.message.employeeCreated": "Employee created successfully",
    "notifications.message.employeeUpdates": "Employee updated successfully",
    "notifications.message.surveyTypeCreated": "Survey Type created successfully",
    "notifications.message.surveyTypeUpdated": "Survey Type updated successfully",
    "notifications.message.templateCreated": "Library Action successfully created",
    "notifications.message.templateRemoved": "Library Action successfully removed",
    "notifications.message.templateUpdated": "Library Action successfully updated",
    "notifications.message.userPermissionsUpdated": "User Permissions updated successfully",
    "notifications.profile.updateSuccessful": "Your profile has been successfully updated.",
    "notifications.title.done": "Done",
    "notifications.title.newAction": "New Action",
    "notifications.title.survey-migration": "Data migration started",
    "nps.delta": "eNPS",
    "on": "On",
    "oops.something.went.wrong": "Oops, something went wrong",
    "openEnded": "OPEN ENDED",
    "origin.source": "Source",
    "overview.aboveOrgWide": "Scores above Org. Wide Avg.",
    "overview.anonymized": "Anonymized",
    "overview.attributeAnonymized": "Not enough responses to meet your anonymity threshold",
    "overview.attributeBetterOrg": "Primary attributes performing better vs. Organization Wide",
    "overview.attributeCantDisplay": "Primary attributes cannot be displayed",
    "overview.attributeDecrease": "Primary attributes with the largest decreases",
    "overview.attributeIncrease": "Primary attributes with the largest increases",
    "overview.attributeWorseOrg": "Primary attributes performing worse vs. Organization wide",
    "overview.belowOrgWide": "Scores below Org. Wide Avg.",
    "overview.bottom25org": "This {{name}} is scoring in the Bottom 25% of the Org!",
    "overview.compareToEmpty": "Compared to Last Survey value not applicable",
    "overview.emptyPage": "There is no quantitative data for your selected survey(s) or not enough responses based on your confidentiality threshold. Please check back later.",
    "overview.enps": "eNPS scores range from -100 to 100",
    "overview.factorSummary": "Factor Summary",
    "overview.from": "from",
    "overview.highlights": "Highlights",
    "overview.label": "Overview",
    "overview.lastMeasured": "Since Last Survey",
    "overview.lastSurvey": "last survey",
    "overview.noLastSurvey": "Heads up! This is the first survey on of it's kind. So you won't see any comparison info for previous scores.",
    "overview.noPreviousSurvey": "No previous survey to compare to",
    "overview.orgDifferEnabled": "Heads up! Scores in Top 25% and Bottom 25% are only available for viewing People Leader without any other filters. We have added some other useful info as a replacement!",
    "overview.orgRankDisabled": "Heads up! Use any filter to automatically get Org. Wide comparison data and filtering to a specific people leader will show the Top 25% and Bottom 25% stats.",
    "overview.orgWideBottom": "Scores in the Bottom 25% of the Org.",
    "overview.orgWideEmpty": "Compared to Org Wide value not applicable",
    "overview.orgWideIsSame": "Score is equal to Org Wide score",
    "overview.orgWideTop": "Scores in the Top 25% of the Org.",
    "overview.orgwideCompare": "Compared to Org Wide",
    "overview.permissionGroup": "Based on your access, the following group(s) are part of your results: {{label}}",
    "overview.questionSummary": "Question Summary",
    "overview.responseRate": "Response Rate",
    "overview.scoreDecrease": "This score decreased significantly!",
    "overview.scoreDifferDisabled": "Heads up! We can't show you previous survey comparison data when viewing data for multiple surveys.",
    "overview.scoreHugeDecrease": "Significant Decrease in Score",
    "overview.scoreHugeIncrease": "Significant Increase in Score",
    "overview.scoreIncrease": "This score increased significantly!",
    "overview.scoreIsSame": "Score did not shift since last measured",
    "overview.seeAllFactors": "See all Factors",
    "overview.seeAllQuestions": "See all Questions",
    "overview.seeAllScores": "See full score details",
    "overview.since": "since",
    "overview.top25Org": "This {{name}} is scoring in the Top 25% of the Org!",
    "overview.vsOrgWide": "vs. Org Wide Avg",
    "participants-dialog.cancel": "Cancel",
    "participants-dialog.column.employee": "Employee",
    "participants-dialog.column.invited-date": "Invited date",
    "participants-dialog.column.submitted-date": "Submitted date",
    "participants-dialog.confirm": "show only this person’s responses",
    "participants-dialog.not.yet.invited": "Not invited",
    "participants-dialog.not.yet.submitted": "Not submitted",
    "participants-dialog.search.placeholder": "Filter participants",
    "participants-dialog.title": "Select survey participant",
    "participants.actions": "Actions",
    "participants.actions.removeFromList": "Remove from list",
    "participants.actions.resend": "Re-send invitation",
    "participants.actions.revoke": "Revoke access and delete data",
    "participants.addButton": "ADD PARTICIPANTS...",
    "participants.channel.failed": "Last invitation via {{channel}} failed to send",
    "participants.channel.name.email": "email",
    "participants.channel.name.sms": "SMS",
    "participants.channel.none": "No invitations yet via {{channel}}",
    "participants.channel.pending": "An invitation will be sent via {{channel}}",
    "participants.channel.sent": "Last invited via {{channel}} on {{date}}",
    "participants.channel.sms.noPhone": "No phone number on file",
    "participants.channel.sms.optedOut": "Person is on the SMS Opt-Out list",
    "participants.chip.addedNotInvited": "Added on {{date}}, not invited yet",
    "participants.chip.alreadyInvited": "ALREADY INVITED",
    "participants.chip.deactivated": "DEACTIVATED",
    "participants.chip.invited": "Invited on {{date}}",
    "participants.chip.notInvited": "NOT INVITED YET",
    "participants.chip.onTheList": "ON THE LIST",
    "participants.emptyFilter": "No participants match the current filters.",
    "participants.emptyState": "There are no recipients selected for this survey.",
    "participants.filter.search": "Filter by participant name, email, or ID",
    "participants.filter.status": "Filter by participant status",
    "participants.filter.status.all": "All statuses",
    "participants.filter.status.invited": "Received invitation",
    "participants.filter.status.notInvited": "Not yet invited",
    "participants.groupAction": "Group action for {{count}} selected",
    "participants.groupAction.all": "All participants",
    "participants.groupAction.invited": "Already participating employees",
    "participants.groupAction.notInvited": "Not yet invited employees",
    "participants.groupAction.remove": "Remove from participant list",
    "participants.groupAction.resend": "Re-send invitations",
    "participants.groupAction.revoke": "Revoke access and delete data",
    "participants.groupAction.unselectAll": "Unselect all",
    "participants.modal.disabledCheckbox": "Disabled checkbox means that the employee is already participating in the survey",
    "participants.modal.disabledRowTooltip": "Cannot remove already invited employees from the list. If invited by mistake, revoke their access and delete survey data from the participant list.\n\nPlease note that invited employees do not get another invitation email every time you add more recipients.",
    "participants.modal.email": "Email",
    "participants.modal.employeeId": "ID",
    "participants.modal.employeeList": "Employee list",
    "participants.modal.employeeName": "Employee name",
    "participants.modal.filterByAttribute": "Filter by attribute",
    "participants.modal.filterByDate": "Filter by date",
    "participants.modal.filterByDate.add": "ADD START DATE FILTER",
    "participants.modal.filterByDate.after": "After date",
    "participants.modal.filterByDate.before": "Before date",
    "participants.modal.filterByDate.beforeIncluding": "Before and including date",
    "participants.modal.filterByDate.between": "Between two dates",
    "participants.modal.filterByDate.custom": "Custom date or date range...",
    "participants.modal.filterByDate.includingAndAfter": "Including date and after",
    "participants.modal.filterByDate.label": "Employee start date is...",
    "participants.modal.filterByDate.lastWeek": "Last week",
    "participants.modal.filterByDate.notBetween": "Not between two dates",
    "participants.modal.filterByDate.notOn": "Not on date",
    "participants.modal.filterByDate.onExact": "On exact date",
    "participants.modal.filterByDate.remove": "Remove filter",
    "participants.modal.filterByDate.select": "Select...",
    "participants.modal.filterByDate.shortcuts": "Shortcuts",
    "participants.modal.filterByDate.sinceYesterday": "Since yesterday",
    "participants.modal.filterByDate.thisMonth": "This month",
    "participants.modal.filterByDate.thisWeek": "This week",
    "participants.modal.filterByEmployee": "Filter by employee",
    "participants.modal.filterByEmployee.placeholder": "Enter name, email, or ID",
    "participants.modal.filterByEmployee.remove": "Remove filter",
    "participants.modal.filterSubtitle": "Employee list will respond to all selected filters",
    "participants.modal.filterTitle": "Filter employee list",
    "participants.modal.newParticipants_one": "{{count}} new participant",
    "participants.modal.newParticipants_other": "{{count}} new participants",
    "participants.modal.removed": "{{count}} removed",
    "participants.modal.save": "SAVE",
    "participants.modal.saveWith": "SAVE WITH {{details}}",
    "participants.modal.selectAll": "SELECT ALL",
    "participants.modal.title": "Add participants from employee list",
    "participants.modal.unselectAll": "UNSELECT ALL",
    "participants.revoke.confirm.body.multiple": "Removing participants will revoke their invitation and access to the survey, and remove their survey data, in case they already submitted it. This action cannot be undone.\n\nYou will be able to invite them to the survey again, but their data will be erased.\n\nAre you sure you want to remove these participants?",
    "participants.revoke.confirm.body.single": "Removing participants will revoke their invitation and access to the survey, and remove their survey data, in case they already submitted it. This action cannot be undone.\n\nYou will be able to invite them to the survey again, but their data will be erased.\n\nAre you sure you want to remove this participant?",
    "participants.revoke.confirm.button.multiple": "YES, REMOVE ALL {{count}}",
    "participants.revoke.confirm.button.single": "YES, REMOVE",
    "participants.revoke.confirm.title.multiple": "Remove {{count}} participants?",
    "participants.revoke.confirm.title.single": "Remove participant {{firstName}} {{lastName}}?",
    "participants.revoke.success.multiple": "Participants removed successfully",
    "participants.revoke.success.single": "Participant removed successfully",
    "participants.table.email": "Email",
    "participants.table.invitationChannel": "Invitation channel",
    "participants.table.name": "Name",
    "participants.table.status": "Status",
    "participants.unsavedChanges": "You have unsaved changes to the participant list. Make sure to save them before you leave this screen.",
    "passive": "Neutral",
    "passive.2": "Passive",
    "password.reset.email": "Someone has requested a link to reset your password for the WorkTango platform.",
    "password.reset.error": "This reset password link is invalid, has expired or has already been used once.",
    "password.strength.tooltip": "Your password input is compared to a library of over 30,000 common passwords, names, and surnames, popular English words from Wikipedia, US television, movies, and other common patterns like dates, repeats (aaa), sequences (abcde), keyboard patterns (qwertyuiop), and l33t speak (p4ssw0rd).",
    "pending": "Pending",
    "people": "people",
    "percentage": "Percentage",
    "permission.accessAiAssistant": "User",
    "permission.aiAssistant": "WorkTango Coach",
    "permission.aiAssistantPermissionLevel": "WorkTango Coach Permission Level",
    "permission.manageActionsForAll": "Action Planning: All Users",
    "permission.manageActionsUnderHierarchy": "Action Planning: Only Hierarchy",
    "permission.manageAiAssistant": "Admin",
    "permission.manageCompany": "Configuration",
    "permission.manageEmployees": "Employees",
    "permission.manageUsers": "Users",
    "permission.manageUsersAndEmployees": "Users and Employees",
    "permission.receivesSummaryEmail": "Receives post-survey email",
    "permission.task.attributes": "Also view and manager actions for the following attribute(s):",
    "permission.task.main": "View and mange actions for:",
    "permission.task.self": "Only themselves",
    "permissions.canFilterSurveyComments": "Filter Comments",
    "permissions.canManageSurveys": "Manage Surveys",
    "permissions.canSeeComments": "View Comments",
    "permissions.canSeeConversations": "Anonymous Conversations",
    "permissions.canSeeInProgressResults": "View In Progress Reporting",
    "permissions.canSeeReporting": "View Reporting",
    "permissions.canUpdateCommentSentiment": "Update Comment Sentiment",
    "permissions.canViewBenchmarks": "View Benchmarks",
    "permissions.loading.hierarchy": "Loading hierarchies…",
    "person": "person",
    "picker.noOption": "No options available",
    "pl-pl": "Polish",
    "positive.sentiment": "Positive Sentiment",
    "ppt.questions.breakdown": "Question(s) Breakdown",
    "ppt.score": "Score",
    "presentaionExport.spreadChart.favorable": "Favourable",
    "presentaionExport.spreadChart.neutral": "Neutral",
    "presentaionExport.spreadChart.unfavorable": "Unfavourable",
    "presentationExport.appendix": "Appendix",
    "presentationExport.appendix.allQuestionsSlide.title": "All Quantitative Questions",
    "presentationExport.appendix.breakdown": "Breakdown",
    "presentationExport.attributeDisclaimer": "Only shown to respondents with the following attribute(s) conditions:",
    "presentationExport.bottomFiveQuestions": "Bottom Five Questions",
    "presentationExport.compareType.attribute": "Compared to Comparison Attribute(s)",
    "presentationExport.compareType.organization": "Compared to Org. Wide",
    "presentationExport.compareType.survey": "Compared to Comparison Survey(s)",
    "presentationExport.comparedWith": "Compared with",
    "presentationExport.comparisonAttributes": "Comparison Attribute(s)",
    "presentationExport.comparisonSurveys": "Comparison Survey(s)",
    "presentationExport.confidential": "Proprietary and Confidential. © 2022 WorkTango Inc.",
    "presentationExport.dropdownQuestionSlide.title": "Dropdown Questions",
    "presentationExport.enps": "eNPS",
    "presentationExport.enpsSlide.description.compareValue.comparisonAttribute": "change vs Comparison Attribute",
    "presentationExport.enpsSlide.description.compareValue.comparisonSurvey": "change vs Comparison Survey",
    "presentationExport.enpsSlide.description.compareValue.orgWide": "change vs Org Wide",
    "presentationExport.enpsSlide.description.compareValue.timeframe": "Change vs Timeframe",
    "presentationExport.enpsSlide.detractors": "Detractors",
    "presentationExport.enpsSlide.detractorsDescription": "employees who are ”Detractors”",
    "presentationExport.enpsSlide.employeeBreakdown": "Employee Breakdown",
    "presentationExport.enpsSlide.enpsDescription": "Employee Net Promoter Score (eNPS) provides an overall measure of employee engagement by measuring how willing the employee is to recommend their workplace to friends and family.",
    "presentationExport.enpsSlide.enpsFormula": "General benchmarks indicate a score of 5-30 as average, 30+ as above average, and less than 5 as below average.",
    "presentationExport.enpsSlide.passives": "Passives",
    "presentationExport.enpsSlide.promoters": "Promoters",
    "presentationExport.enpsSlide.promotersDescription": "employees who are ”Promoters”",
    "presentationExport.factorsSlide.byFactor": "By Factor",
    "presentationExport.factorsSlide.keyFactors": "Key Factors",
    "presentationExport.factorsSlide.otherFactors": "Factors",
    "presentationExport.filters": "Filters",
    "presentationExport.mcqSlide.title": "Multiple Choice Questions",
    "presentationExport.openEndedCommentsSlide.frequency": "Frequency",
    "presentationExport.openEndedCommentsSlide.keyword": "Keyword",
    "presentationExport.openEndedCommentsSlide.majoritySentiment": "Majority Sentiment",
    "presentationExport.openEndedCommentsSlide.respondents": "respondents",
    "presentationExport.openEndedCommentsSlide.sentimentDescription": "*Note: Sentiments reflects key words with a majority of positive, neutral and negative comments as determined by Amazon’s natural language processing (NLP) engine; please visit the WorkTango platform for detailed comments and sentiment noted for each comment",
    "presentationExport.openEndedCommentsSlide.title": "Open-Ended Comments",
    "presentationExport.overallFindings": "Overall Findings",
    "presentationExport.question": "Question:",
    "presentationExport.questionThemes": "Question Themes",
    "presentationExport.resultsSlide.factorCompareAttr": "Percentage difference for above factor when compared to selected Attribute(s)",
    "presentationExport.resultsSlide.factorCompareOrgWide": "Percentage difference for above factor when compared to Organization Wide",
    "presentationExport.resultsSlide.factorCompareSurvey": "Percentage difference for above factor when compared to Comparison Survey(s)",
    "presentationExport.resultsSlide.factorCompareTimeframe": "Percentage difference for above factor when comparing timeframes",
    "presentationExport.resultsSlide.highestFactor": "Highest scoring factor",
    "presentationExport.resultsSlide.highestQuestion": "Highest scoring question",
    "presentationExport.resultsSlide.keyResults": "Key Results",
    "presentationExport.resultsSlide.lowestFactor": "Lowest scoring factor",
    "presentationExport.resultsSlide.lowestQuestion": "Lowest scoring question",
    "presentationExport.resultsSlide.questionCompareAttr": "Percentage difference for above question when compared to selected Attribute(s)",
    "presentationExport.resultsSlide.questionCompareOrgWide": "Percentage difference for above question when compared to Organization Wide",
    "presentationExport.resultsSlide.questionCompareSurvey": "Percentage difference for above question when compared to Comparison Survey",
    "presentationExport.resultsSlide.questionCompareTimeframe": "Percentage difference for above factor when comparing timeframes",
    "presentationExport.resultsSlide.respondents": "Employees responded",
    "presentationExport.resultsSlide.responseRate": "Response Rate",
    "presentationExport.resultsSlide.responseRateCompareAttr": "Percentage difference from Comparison Attribute(s)\nresponse rate",
    "presentationExport.resultsSlide.responseRateCompareOrgWide": "Percentage difference from Organization Wide\nresponse rate",
    "presentationExport.resultsSlide.responseRateCompareSurvey": "Percentage difference from Comparison Survey’s\nresponse rate",
    "presentationExport.resultsSlide.responseRateCompareTimeframe": "Percentage difference from compared timeframe response rate",
    "presentationExport.resultsSlide.responseRate_plural": "Responses",
    "presentationExport.resultsSlide.title": "Summary of Results",
    "presentationExport.summaryGeneratedWithResponses": "This summary was generated by AI analyzing {{responses}} responses.",
    "presentationExport.title.report-timeframe": "Report Timeframe",
    "presentationExport.title.report-timeframe.empty": "No Timeframe selected",
    "presentationExport.topFiveQuestions": "Top Five Questions",
    "presentationExport.yesNoQuestionSlide.title": "Yes/No Questions",
    "privacy.notice": "Privacy notice",
    "privacy.policy": "Privacy policy",
    "profile.avatar": "Avatar",
    "profile.avatarErrorSize": "Invalid file size of {{fileSize}} KB. Maximum {{maxFileSize}} KB.",
    "profile.avatarErrorType": "Not a valid image file.",
    "profile.confirmPassword": "Confirm Password",
    "profile.currentpassword": "Current Password",
    "profile.fname": "First Name",
    "profile.lname": "Last Name",
    "profile.newpassword": "New Password",
    "profile.password": "Password",
    "profile.picture": "Profile Image",
    "profile.saved": "Saved",
    "profile.selectLanguage": "Select Language",
    "profile.updateSuccessful": "Your profile has been successfully updated.",
    "promoter.2": "Promoter",
    "pt-br": "Portuguese (BR)",
    "pt-pt": "Portuguese (PT)",
    "published": "Published",
    "question.add-to-library": "Add to library",
    "question.cannotDiscontinue": "This question cannot be discontinued because it’s a part of question logic.\nPlease disassociate the question in the Logic Editor, and then discontinue it.",
    "question.cannotDiscontinue.title": "This question cannot be discontinued",
    "question.confirmDiscontinue": "Yes, discontinue",
    "question.delete": "Delete",
    "question.discontinue": "Discontinue question",
    "question.discontinueDesc": "By confirming this action you will irreversibly remove this questions from the survey. All reporting will still be available for it.\n\nAre you sure you want to proceed with this change?",
    "question.discontinueThisQuestion": "Discontinue this question?",
    "question.discontinuingQuestion": "Discontinuing the question...",
    "question.duplicate": "Duplicate",
    "question.issue.attrEmpty": "Please select attribute value(s)",
    "question.issue.attributeFilterEmpty": "Please select an attribute for the attribute filter",
    "question.issue.categoryEmpty": "Factor must be selected",
    "question.issue.descEmpty": "Please input question description for all language(s)",
    "question.issue.isPrevious": "Trending Question is ineditable",
    "question.issue.leftEmpty": "Please input left label for all language(s)",
    "question.issue.optionsEmpty": "Please input options content for all language(s)",
    "question.issue.questionFilterLabelEmpty": "Please input a question filter label",
    "question.issue.rightEmpty": "Please input right label for all language(s)",
    "question.issue.titleEmpty": "Please input question title for all language(s)",
    "question.lock.attributeBased": "All employee access required for editing attribute based question",
    "question.locked": "This question can't be edited as it is now a trending question. If you want to edit the question, you can duplicate it and edit the duplicated version.",
    "question.multiple.error": "Please change \"Selections Allowed\" to 2 or more to continue.",
    "question.order": "Drag",
    "question.remove-from-library": "Remove from library",
    "question.saved.success": "Question saved successfully.",
    "question.showDiscontinued": "Show discontinued questions ({{count}})",
    "question.toast.success.discontinue": "Success! Question will no longer be asked in this survey.",
    "question.upload": "Add to Library",
    "question.uploaded": "This question is in your library, click to remove",
    "questionExport.Description": "Description",
    "questionExport.FactorName": "Factor",
    "questionExport.Question": "Question",
    "questionExport.benchmarkedQuestion": "Benchmarked Question",
    "questionExport.commentsTurnedOn": "comments turned on?",
    "questionExport.isBenchmarked": "Is Benchmarked",
    "questionExport.isConditionalOnAttribute": "Conditionally shown based on Attribute?",
    "questionExport.isConditionalOnPreviousQuestion": "Conditionally shown based on Previous Question?",
    "questionExport.isQuestionRequired": "is question required?",
    "questionExport.isTrend": "will question trend with other surveys?",
    "questionExport.questionNumber": "Question #",
    "questionExport.questionType": "Question Type",
    "questionExport.responseOptions": "Response Options",
    "questions": "Questions",
    "questions.none": "Add your first question",
    "questions.none.message": "Click the \"+\" button to add a question to this survey.",
    "questions.select.attributesAndValue": "Select field and value",
    "recipients": "Recipients",
    "recipients.added_one": "add {{count}} new participant",
    "recipients.added_other": "add {{count}} new participants",
    "recipients.all": "All Employees",
    "recipients.change-confirmation": "Are you sure you want to proceed with this change?",
    "recipients.changed.dialog.button.confirm": "Confirm change",
    "recipients.changed.dialog.title": "Survey participants update summary",
    "recipients.description.added": "By confirming this update you will <0>{{addedText}}</0>, and send them a survey invitation email.",
    "recipients.description.both": "By confirming this update you will <0>{{addedText}}</0>, and <0>{{removedText}}</0>. Added participants will be sent an invitation email.",
    "recipients.description.removed": "By confirming this update you will <0>{{removedText}}</0>. ",
    "recipients.removed-warning": "Removed participants' survey access will no longer be valid and <0>all their submitted answers will be deleted.</0>",
    "recipients.removed_one": "remove {{count}} existing participant",
    "recipients.removed_other": "remove {{count}} existing participants",
    "reminder.schedule.already.sending.error": "Survey invitations are currently being sent for this survey. Perhaps a reminder was already scheduled?",
    "reminder.title.date.time": "Reminder Date & Time",
    "reminder.title.status": "Status",
    "reminders.invitation-time.tooltip": "This is when your reminders enter the send queue, not necessarily when recipients receive them. Please note that  the delivery may take up to 3 hours after the window starts to maintain email deliverability standards.",
    "remove.all.compare.attributes": "This action will remove all custom comparable attributes.",
    "remove.all.custom.response.attributes": "This action will remove all custom response data attributes.",
    "remove.all.filter.attributes": "This action will remove all custom filtering attributes.",
    "remove.all.other.hierarchies": "This action will remove all selected people leaders.",
    "reporting.compare.withFilterNotice": "Comparison data also filtered with applied filters",
    "reporting.compare.withoutFilterNotice": "Comparison data not filtered with applied filters",
    "reporting.export.fullResponses": "Results (Individual)",
    "reporting.export.raw-export": "Raw survey data export",
    "reporting.filter.or": "or",
    "reporting.nonRespondents": "Non-respondents",
    "reporting.outOf": "out of",
    "reporting.participant.filter.reset.button": "reset report to all participants",
    "reporting.participant.filter.select.button": "select a participant...",
    "reporting.participant.filter.selectAnother.button": "select a different participant...",
    "reporting.participant.filter.selected": "Report is limited to <0>responses submitted by {{name}}</0>",
    "reporting.responded": "responded",
    "reporting.respondents": "Respondents",
    "reporting.timeframeCompare.dialog.aMonthPriorToReport": "A month prior to Report",
    "reporting.timeframeCompare.dialog.aWeekPriorToReport": "A week prior to Report",
    "reporting.timeframeCompare.dialog.custom": "Custom timeframe",
    "reporting.timeframeCompare.dialog.description1": "This action will choose a different timeframe to compare data against the Report timeframe",
    "reporting.timeframeCompare.dialog.description2": "Compare With timeframe selection",
    "reporting.timeframeCompare.dialog.quarterPriorToReport": "Quarter prior to report",
    "reporting.timeframeCompare.dialog.samePeriodLastYear": "Same period last year",
    "reporting.timeframeCompare.dialog.threeMonthsPriorToReport": "3 months prior to Report",
    "reporting.timeframeCompare.dialog.title": "Choose Compare With Timeframe",
    "reporting.timeframeCompare.option.aMonthPriorToReport": "A month prior to Report",
    "reporting.timeframeCompare.option.aWeekPriorToReport": "A week prior to Report",
    "reporting.timeframeCompare.option.custom": "Custom timeframe",
    "reporting.timeframeCompare.option.quarterPriorToReport": "Quarter prior to report",
    "reporting.timeframeCompare.option.samePeriodLastYear": "Same period last year",
    "reporting.timeframeCompare.option.threeMonthsPriorToReport": "3 months prior to Report",
    "reporting.timeframeFilter.button": "Change Timeframe...",
    "reporting.timeframeFilter.dialog.description1": "This action will limit the report to consider only the responses submitted in the selected timeframe.",
    "reporting.timeframeFilter.dialog.description2": "Report timeframe selection",
    "reporting.timeframeFilter.dialog.filterLabel": "Selected timeframe",
    "reporting.timeframeFilter.dialog.title": "Change Report Timeframe",
    "reporting.timeframeFilter.label": "Report timeframe is limited to",
    "reporting.timeframeFilter.option.AllTime": "All time",
    "reporting.timeframeFilter.option.Custom": "Custom",
    "reporting.timeframeFilter.option.Last30Days": "Last 30 days",
    "reporting.timeframeFilter.option.Last7Days": "Last 7 days",
    "reporting.timeframeFilter.option.Last90Days": "Last 90 days",
    "reporting.timeframeFilter.option.PreviousQuarter": "Previous quarter",
    "reporting.timeframeFilter.option.SinceBeginningOfYear": "Since beginning of year",
    "reporting.timeframeFilter.option.ThisQuarter": "This quarter",
    "resend.emails.in.progress": "A request to resend survey invitations to participants is already in progress. Please wait for this request to complete before trying again.",
    "reset.filters": "Reset filters",
    "reset.password.dialog.description": "Your new password is ready to use.",
    "reset.password.dialog.title": "New Password Set Up Complete!",
    "reset.password.instruction": "Set up your new password",
    "response.comment": "Enter Optional Comment",
    "response.entities.sentiment": "Sentiment",
    "response.entities.sentimentscore": "Score",
    "responseRate.responses": "{{detail}} responses",
    "responseRates": "Response Rates",
    "responserates.answered": "Answered",
    "responserates.total": "Total",
    "responses.count": "Responses Count",
    "responses.count.compare-timeframe": "Compare Timeframe responses count",
    "result.commentSentiment.negative": "Negative",
    "result.commentSentiment.neutral": "Neutral",
    "result.commentSentiment.positive": "Positive",
    "result.commentSentiment.unknown": "Unknown",
    "result.noPositiveSentiment": "No Positive Sentiment",
    "results.moreDetails": "More Details",
    "results.responded": "Responded",
    "results.see": "See",
    "return.home": "Return to home page",
    "role.current.direct.reports": "Current Direct Report",
    "role.current.hierarchy": "Current Hierarchy Report",
    "role.directReport": "Direct Report",
    "role.hierarhcyReport": "Hierarchy Report",
    "role.peopleleader": "People Leader",
    "roles.actionPlanning.all": "All Actions",
    "roles.actionPlanning.default": "Only their actions",
    "roles.actionPlanning.hierarchy": "Hierarchy only",
    "roles.addRole": "Add Role",
    "roles.column.actionPlanning": "Action Planning Access",
    "roles.column.other": "Other Permissions",
    "roles.column.role": "Role",
    "roles.column.surveyType": "Survey Type Access",
    "roles.column.users": "No. of Users",
    "roles.create.desc": "Create a role by defining a set of permissions that users of a certain group need to access the platform. Once you have the role created, assign the role to the respective users via the Users section.",
    "roles.create.error": "Oops, looks like we're missing something",
    "roles.create.errorDesc": "Please check the following validations:",
    "roles.create.successDesc": "{{name}} has been successfully saved.",
    "roles.create.successTitle": "New Role Created",
    "roles.create.title": "Create a new role",
    "roles.delete.preventDesc": "Please assign all the users with the HR BP role to a different role before deleting this role.",
    "roles.delete.preventDesc.automaticallyCreated": "This is a system role and can't be deleted.",
    "roles.delete.preventKazooDefaultRole": "This is a default role and can not be deleted from within the Surveys and Insights module. Please reach out to your customer service admin for more information on default roles. ",
    "roles.delete.preventTitle": "This role has users assigned to it.",
    "roles.delete.preventTitle.default": "This role can't be deleted",
    "roles.delete.preventTitle.kazooDefaultRole": "Cannot delete role",
    "roles.delete.successDesc": "{{name}} has been successfully deleted.",
    "roles.delete.successTitle": "Role deleted",
    "roles.empty": "Nothing here at the moment... let's change that!",
    "roles.input.name": "Role Name",
    "roles.mainTitle": "Roles",
    "roles.other.none": "None",
    "roles.searchLabel": "Search by role",
    "roles.surveyType.all": "All",
    "roles.surveyType.attribute": "Attribute Based",
    "roles.surveyType.hierarchy": "Hierarchy",
    "roles.update.alertConfirm": "Confirm changes",
    "roles.update.alertDesc": "By continuing, any users with this role will have their permissions updated based on the new permissions",
    "roles.update.alertTitle": "Updating this role will affect current users with this role",
    "roles.update.successDesc": "{{name}} has been successfully saved.",
    "roles.update.successTitle": "Role updated",
    "roles.update.title": "Edit Role",
    "rows.per.page": "Rows per page:",
    "ru-ru": "Russian",
    "schedule.time.early-morning": "Early morning (6-8am)",
    "schedule.time.eod": "End of day (4-6pm)",
    "schedule.time.evening": "Evening (8-10pm)",
    "schedule.time.noon": "Noon to lunch (12pm-2pm)",
    "scheduled": "Scheduled",
    "scoreByAttrSpread": "Spread Of Score By Attribute",
    "search.for.content": "Search for content...",
    "search.placeholder": "Search...",
    "search.question.title": "Search for a question",
    "see.all": "See all",
    "see.more.something": "See more {{something}}",
    "select": "Select",
    "select.all": "Select all",
    "select.an.attribute": "Select an attribute",
    "select.choosesurvey": "Filter by Survey",
    "selected.survey.status.header": "Status",
    "selected.survey.styles.header": "Survey Styles",
    "selected.survey.types.header": "Survey Types",
    "send.password.reset.email": "Send password reset email",
    "sentimentCloud.noAvailableData": "No available data",
    "sentimentCloud.slider.title": "Displaying Key Phrases: ",
    "sentiments.set": "Click to change the {{sentiment}} sentiment.",
    "sentiments.set.negative": "Set to Negative",
    "sentiments.set.neutral": "Set to Neutral",
    "sentiments.set.positive": "Set to Positive",
    "sentiments.set.unknown": "Reset to Unknown",
    "settings.add.survey.type": "Add Survey Type",
    "settings.alert.baseCategory.warningDescription": "You can still receive WorkTango's recommended Suggestions by linking your custom factor with a WorkTango factor above and customizing the name.",
    "settings.alert.baseCategory.warningTitle": "Custom Factors won’t have any recommended Suggestions",
    "settings.alert.recommendation": "Suggestions for this factor will be powered by WorkTango's recommendations for <strong>{{categoryName}}</strong>.",
    "settings.company.genai-dialog-body": "Our platform is employing third party artificial intelligence capabilities to perform the following actions:\n<0>Text comment sentiment analysis</0>\n<0>Text comment theme extraction and association</0>\n<0>Short summary of text comments</0>\n<0>Recommending actions based on text comments</0>\n<0>Generate Text comment entities</0>\n<1>Create Text commend word cloud</1>\n\nYour data is not being stored by third party, nor is it being used for any AI model training. To find our more about WorkTango’s AI policies, please follow <2>this link.</2>",
    "settings.company.genai-dialog-title": "About WorkTango’s AI features",
    "settings.company.genai-settings": "Generative AI Settings",
    "settings.company.genai-settings-tooltip": "Click to find out more about WorkTango’s AI features",
    "settings.company.genai.comment-analysis": "Enable AI features",
    "settings.company.language-settings": "Language Settings",
    "settings.company.open-surveys-settings": "Open Surveys",
    "settings.company.open-surveys.enabled": "Enable Shared Link surveys",
    "settings.company.salesforceId": "SalesForce ID",
    "settings.company.salesforceId.helperText": "This field is only visible to WorkTango admins",
    "settings.customFactor": "Custom Factor",
    "settings.customizeName": "Customize Name",
    "settings.desc.baseSurveyType": "Select the category to get a recommended list of factors and automatic suggestions to improve your scores",
    "settings.desc.factors": "Factors group similar themed questions together, allowing you to see the overall score for the question group. We recommend our industry-approved factors, which will provide you automatic recommendations on how to improve your scores.",
    "settings.desc.surveyTypes": "Survey Types allow you to group similar surveys that have the same permission structure and share the same anonymity threshold.",
    "settings.done": "Done",
    "settings.done.message": "You settings have been updated successfully.",
    "settings.edit.survey.type": "Edit Survey Type",
    "settings.employee-attribute.deletion": "Employee attribute was deleted successfully!",
    "settings.employeeAttribute.archiveAttribute": "Archive attribute",
    "settings.employeeAttribute.archiveAttributeConfirmTitle": "Archive attribute \"{{name}}\"?",
    "settings.employeeAttribute.archiveImpact.bucket.compare": "Compare attributes",
    "settings.employeeAttribute.archiveImpact.bucket.dataset": "Dataset attributes",
    "settings.employeeAttribute.archiveImpact.bucket.visible": "Filter attributes",
    "settings.employeeAttribute.archiveImpact.confirm": "Archive Anyway",
    "settings.employeeAttribute.archiveImpact.intro": "This will leave permissions empty for:",
    "settings.employeeAttribute.archiveImpact.loading": "Checking permission impact…",
    "settings.employeeAttribute.archiveImpact.role": "{{name}} (role)",
    "settings.employeeAttribute.archiveImpact.title": "Archive \"{{name}}\"?",
    "settings.employeeAttribute.archiveModalBody": "Archiving an attribute will hide it in the system, but preserve all employee data stored in it in case you decide to reactivate it later.\n\nAll previous surveys will remain intact, but going forward you will not be able to view or filter new survey results using this attribute any longer.\n\nIf your intent is to permanently remove this attribute, including employee and historical survey data, then consider deleting it instead.\n\nAre you sure you want to archive this attribute?",
    "settings.employeeAttribute.confirmYesArchive": "Yes, archive",
    "settings.employeeAttribute.confirmYesDelete": "Yes, delete",
    "settings.employeeAttribute.confirmYesReactivate": "Yes, reactivate",
    "settings.employeeAttribute.deleteAttribute": "Delete attribute",
    "settings.employeeAttribute.deleteAttributeConfirmTitle": "Delete attribute \"{{name}}\"?",
    "settings.employeeAttribute.deleteModalBody": "Deleting an attribute will permanently remove it from the system, and delete all Employee data stored in it. This action cannot be undone.\n\nAll current and previous surveys will also get affected by this action, and you will not be able to view or filter survey results using this attribute any longer.\n\nIf your intent is to discontinue using this attribute, but preserve historical data, consider archiving it instead.\n\nAre you sure you want to delete this attribute?",
    "settings.employeeAttribute.reactivateModalBody": "Reactivating an archived attribute will make it visible in the system, and will be present in all new surveys, but will not be added to any surveys in progress.\n\nAre you sure you want to reactivate this attribute?",
    "settings.employeeAttributes.duplicateError": "There is already an attribute with the same name. Please choose a different name to continue.",
    "settings.error.baseFactorRequired": "A valid WorkTango factor is required",
    "settings.error.baseSurveyTypeRequired": "A survey category is required",
    "settings.error.enNameRequired": "English name must not be blank",
    "settings.error.invalidSize": "Invalid file size of {{fileSizeKB}} KB. Maximum {{maxUploadSizeKB}} KB.",
    "settings.error.maxedPrimary": "Maximum primary attributes already selected",
    "settings.error.notValidImage": "Not a valid image file.",
    "settings.error.thresholdRequired": "A valid anonymity threshold is required",
    "settings.error.validTypeRequired": "Invalid Employee Attribute type",
    "settings.integrations.channel.slack.description": "Deliver survey invitations to employees through your connected Slack workspace.",
    "settings.integrations.channel.slack.label": "Slack",
    "settings.integrations.channel.sms.description": "Deliver survey invitations to employees by text message.",
    "settings.integrations.channel.sms.label": "SMS",
    "settings.integrations.channel.teams.description": "Deliver survey invitations to employees through Microsoft Teams.",
    "settings.integrations.channel.teams.label": "Microsoft Teams",
    "settings.integrations.configure": "CONFIGURE",
    "settings.integrations.description": "Enable the channels you want to use to deliver survey invitations. Each channel can be paused at any time.",
    "settings.integrations.error": "We couldn't update this channel. Please try again.",
    "settings.integrations.heading": "Messaging channels",
    "settings.integrations.notConnectedHint": "Enabled, but not yet connected. Complete setup to start sending on this channel.",
    "settings.integrations.setup": "Set up",
    "settings.integrations.setup.comingSoon": "Setup for this channel is coming soon.",
    "settings.integrations.slack.connectError": "We couldn't connect Slack. Please try again.",
    "settings.integrations.slack.connected": "Slack connected. You can now deliver survey invitations through Slack.",
    "settings.integrations.status.connected": "Connected",
    "settings.integrations.status.notConnected": "Not connected",
    "settings.integrations.toggle.error": "There was a problem activating SMS for this company. Please refresh the page and try again.",
    "settings.kiosk.attributes": "Kiosk Identifier",
    "settings.kiosk.download-qr-code": "Download QR code",
    "settings.kiosk.language": "Additional information",
    "settings.kiosk.language.tooltip": "This text will be displayed on the kiosk login page for welcome text",
    "settings.kiosk.none": "None",
    "settings.kiosk.qr-code": "Kiosk QR code",
    "settings.label.archived": "Archived",
    "settings.label.baseAttribute": "System",
    "settings.label.createAttribute": "Create Attribute",
    "settings.label.factor": "WorkTango Factor",
    "settings.label.key.factor": "Key Factor",
    "settings.label.modifyAttribute": "Modify Attribute",
    "settings.label.name": "Name",
    "settings.label.newAttribute": "New Attribute",
    "settings.label.phone": "Phone",
    "settings.label.phoneAlt": "Phone Number",
    "settings.label.phoneDisabled": "Phone numbers can be configured only for text-type attributes",
    "settings.label.prepopulateFactors": "Select category",
    "settings.label.primary": "Primary",
    "settings.label.primaryAlt": "Primary (always shown by default, up to 10 allowed)",
    "settings.label.private": "Private",
    "settings.label.privateAlt": "Private (hidden in employee list)",
    "settings.label.required": "Required",
    "settings.label.setup.suggestions": "Click to setup suggestions",
    "settings.label.suggestions.content": "WorkTango's recommended {{categoryName}} Suggestions",
    "settings.label.suggestions.powered.by": "Suggestions Powered By",
    "settings.label.survey.types": "Survey Types",
    "settings.label.type": "Type",
    "settings.label.unique": "Unique",
    "settings.message.categoryUpdated": "Factor has been successfully updated.",
    "settings.message.surveyTypesUpdated": "Survey Type has been successfully updated.",
    "settings.primaryAttributeCannotBeModified": "This is a system attribute and cannot be modified.",
    "settings.selected.baseSurveyType": "Survey Category",
    "settings.title": "Settings",
    "settings.title.automatedInvitations": "Automations",
    "settings.title.categoryUpdated": "Saved",
    "settings.title.company": "Company",
    "settings.title.employee-attributes": "Employee Attributes",
    "settings.title.error": "Error",
    "settings.title.integrations": "Integrations",
    "settings.title.kiosk": "Kiosk",
    "settings.title.surveyTypes": "Survey Types & Factors",
    "settings.title.surveyTypesUpdated": "Saved",
    "settings.title.surveys": "Surveys",
    "settings.useRecommendedName": "Use recommended name",
    "show": "Show",
    "show.all": "Show all",
    "show.all.suggestions": "Show all {{count}} suggestions",
    "show.less": "Show less",
    "sidebar.action-planning": "Action Planning",
    "sidebar.admin.branding": "Company Info",
    "sidebar.admin.data": "Settings",
    "sidebar.admin.employees": "Employees",
    "sidebar.content.library": "Learning Coach",
    "sidebar.inbox": "Conversations",
    "sidebar.mailing-lists": "Mailing lists",
    "sidebar.surveys": "Surveys",
    "skip.disabled.when.required": "Skip is unavailable when question is required",
    "sliding_accessible_ms_custom_blue": "Numerical (Square) Blue, Accessible",
    "sliding_accessible_squares": "Numerical (Square), Accessible",
    "sliding_apples": "Apples",
    "sliding_blush": "Blush-Smile Emoji",
    "sliding_boat": "Boat",
    "sliding_canada": "Canadian Flags",
    "sliding_computer": "Computers",
    "sliding_cpa_custom_emoji": "Emoji 5-rating only",
    "sliding_crown": "Crowns",
    "sliding_desk": "Desks",
    "sliding_double_phones": "Two Phones",
    "sliding_eyes_closed_happy_emoji": "Eyes-Closed Happy Emoji",
    "sliding_flags": "Flags",
    "sliding_hands_up": "Hands up",
    "sliding_headphones_happy_face_emoji": "Headphones Happy Emoji",
    "sliding_hearts": "Hearts",
    "sliding_hearts_united_way": "Hearts United Way",
    "sliding_lemur": "Lemur",
    "sliding_lightbulb": "Lightbulb",
    "sliding_music_note": "Music Notes",
    "sliding_office_chair": "Office Chairs",
    "sliding_otter": "Otter",
    "sliding_panda": "Panda",
    "sliding_pencil": "Pencils",
    "sliding_penguin": "Penguin",
    "sliding_phone_in_hand": "Phone in Hand",
    "sliding_pint_glasses": "Pint Glasses",
    "sliding_pizza": "Pizza Slice",
    "sliding_puppy": "Puppy Face",
    "sliding_single_phone": "Single Phone",
    "sliding_speech_bubbles": "Speech Bubbles",
    "sliding_stars": "Stars",
    "sliding_teal_square": "Numerical (Square)",
    "sliding_thumbs_up": "Thumbs Up",
    "sliding_tiff_stars": "Tiff Stars",
    "sliding_wifi": "Wifi Signal",
    "snapshots.update.unknown.error": "There was an error when updating the snapshots",
    "snapshots.updated.successfully": "Snapshots updated successfully",
    "source": "Source",
    "spread": "Spread",
    "spread.of.responses.by.attribute": "Spread Of Response Rates By Attribute",
    "sq-al": "Albanian",
    "sr-rs": "Serbian",
    "sso.loginFailed": "Login failed",
    "sso.loginFailed.invalidToken": "Invalid token",
    "sso.user.not.found.description": "No user was found for {{email}}",
    "star.this": "Star This",
    "starred": "Starred",
    "status.all": "All",
    "suggestions": "Suggestions",
    "summary": "Summary",
    "summaryReport": "Summary Report",
    "support.failure.message": "There was an unexpected error while trying to log you in Zendesk with SSO. Please reach out to support.",
    "survey": "Survey",
    "survey-template.dialog.confirm": "Create survey using selected template",
    "survey-template.dialog.confirm-multiple": "Create survey using selected template as",
    "survey-template.dialog.description": "If you wish to trend a survey, please clone an existing one.",
    "survey-template.dialog.empty-state": "There are no templates that match your filters.",
    "survey-template.dialog.error": "You need to select at least one language",
    "survey-template.dialog.select-language.helper-text": "Important note: changing available languages will not be possible once the survey is created.",
    "survey-template.dialog.select-language.label": "Offer survey in following language(s)",
    "survey-template.dialog.title": "Choose a survey template",
    "survey-template.dialog.tooltip.missing-factors": "There's one or more required Factors missing from this Survey Type. You will have to manually choose Factors for one or more questions.",
    "survey-template.dialog.warning": "These templates will create a net new survey.",
    "survey-template.preview.empty-state": "Select a survey to preview the list of included questions",
    "survey-template.preview.loading": "Loading questions...",
    "survey-template.preview.no-content": "No content",
    "survey-template.preview.title": "Previewing \"{{name}}\"",
    "survey.ai-summary.ask-to-interpret-results": "Ask AI to interpret survey results?",
    "survey.ai-summary.fetch-error": "Error loading AI summary. Please try again.",
    "survey.ai-summary.footer-actions.regenerate": "Regenerate",
    "survey.ai-summary.footer-actions.regenerate-loading": "Regenerating...",
    "survey.ai-summary.generate-error": "Error generating AI summary. Please try again.",
    "survey.ai-summary.generate-success": "AI summary generated successfully",
    "survey.ai-summary.generating": "AI is analyzing survey results. This may take a while...",
    "survey.ai-summary.generating-summary": "Generating summary of survey results",
    "survey.ai-summary.not-performed-with-filters": "AI analysis not performed using applied filters.",
    "survey.aiSummary.noAreasToWatch": "No areas to watch could be determined from the processed data.",
    "survey.aiSummary.noNegativeSentiment": "No areas of opportunity could be determined from the processed data.",
    "survey.aiSummary.noParticipationRate": "No participation rate could be determined from the processed data.",
    "survey.aiSummary.noPositiveSentiment": "No strengths could be determined from the processed data.",
    "survey.aiSummary.noRecommendations": "No recommendations from the processed data.",
    "survey.analyze": "Analyze",
    "survey.approveMigration": "Approve migration",
    "survey.audience.missing.applicable.questions.intro": "Every question in this survey is limited to a specific group, and the following invited employees don't qualify for any of them:",
    "survey.audience.missing.applicable.questions.outro": "Adjust the audience or the survey's targeting before saving.",
    "survey.automatic-reminder.validation.email-content": "Please enter an email content for all languages",
    "survey.automatic-reminder.validation.email-subject": "Please enter an email subject for all languages",
    "survey.automatic-reminder.validation.reminder-frequency": "Please enter a reminder frequency",
    "survey.automatic-reminder.validation.reminder-time": "Please select a reminder time",
    "survey.build.dialog.email-recipients": "Email Recipients",
    "survey.build.dialog.email-to-employees_one": "Email to be sent to {{count}} employee",
    "survey.build.dialog.email-to-employees_other": "Email to be sent to {{count}} employees",
    "survey.build.dialog.once-confirmed-schedule": "Once confirmed, the system will schedule:",
    "survey.build.dialog.sms-no-phone_one": "{{count}} has no phone number",
    "survey.build.dialog.sms-no-phone_other": "{{count}} have no phone number",
    "survey.build.dialog.sms-opted-out_one": "{{count}} has opted out of SMS",
    "survey.build.dialog.sms-opted-out_other": "{{count}} have opted out of SMS",
    "survey.build.dialog.sms-recipients": "SMS Recipients",
    "survey.build.dialog.sms-to-employees_one": "SMS message to be sent to {{count}} employee",
    "survey.build.dialog.sms-to-employees_other": "SMS message to be sent to {{count}} employees",
    "survey.build.new.title": "Save & Schedule?",
    "survey.build.questions.information.about.benchmarks.text": "WorkTango Benchmarks allow you to compare your question results to results from companies similar to your own company. Library Questions with a green icon are by default included in the WorkTango Benchmark program. If you wish to compare the results of one of your own custom questions against the WorkTango benchmark please work with the WorkTango Customer Success team to find an appropriate WorkTango library question to benchmark against.",
    "survey.build.questions.information.about.benchmarks.title": "Information about benchmarks",
    "survey.build.schedule.invitation-date.1-week-after": "Invitation expires after 1 week",
    "survey.build.schedule.invitation-date.2-week-after": "Invitation expires after 2 weeks",
    "survey.build.schedule.invitation-date.custom-number-of-days": "Custom number of days",
    "survey.build.schedule.invitation-date.custom-number-of-days.label": "Days",
    "survey.build.schedule.invitation-date.label": "Invitation valid until",
    "survey.build.schedule.invitation-date.same-as-survey": "Same as survey",
    "survey.build.schedule.invitation-date.tooltip": "Individual invitations can be configured to expire after being sent out. If you enable or disable this feature, only future invitations will get affected.",
    "survey.build.update.title": "Survey Update Summary",
    "survey.button.cancel": "Cancel",
    "survey.button.edit": "Edit survey",
    "survey.button.hideReminders": "Hide reminders",
    "survey.button.remind": "Send Reminder",
    "survey.button.view-reminders": "View Reminders",
    "survey.button.viewReminders": "View reminders",
    "survey.button.viewReports": "View Reports",
    "survey.button.viewReports.noInProgressPermission": "You do not have permission to view reports for surveys in progress",
    "survey.cancel": "Cancel survey",
    "survey.choose-from-template": "Choose from template...",
    "survey.clone": "Clone survey",
    "survey.convert-continuous": "Convert to Continuous survey",
    "survey.convert.dialog.action-text-1": "This action cannot be undone.",
    "survey.convert.dialog.action-text-2": "Are you sure you want to proceed with this change?",
    "survey.convert.dialog.desc-1": "This action will change the survey style from \"Standard\" to \"Continuous\", as described below. This means:",
    "survey.convert.dialog.desc-2": "The survey does not expire, and invitations are automated",
    "survey.convert.dialog.desc-3": "Submitted responses remain available, and become reportable based on invitation date",
    "survey.convert.dialog.desc-4": "All existing invitations remain active",
    "survey.convert.dialog.desc-5": "You need to configure automation triggers after conversion",
    "survey.convert.dialog.option-1": "Continuous survey based on Start Date",
    "survey.convert.dialog.option-2": "Continuous survey based on Exit Date",
    "survey.convert.dialog.option-help-text-1": "Ideal for Onboarding surveys. This survey does not expire, but invitations do, and participants can still respond only once.",
    "survey.convert.dialog.option-help-text-2": "Reporting is performed based on selected timeframes.",
    "survey.convert.dialog.option-help-text-3": "Ideal for Exit surveys. This survey does not expire, but invitations do, and participants can still respond only once.",
    "survey.convert.dialog.option-help-text-4": "Reporting is performed based on selected timeframes.",
    "survey.convert.dialog.option-title": "Please choose a new survey style:",
    "survey.convert.dialog.submit-button": "Yes, Start Conversion",
    "survey.convert.dialog.success-message": "Survey converted successfully.",
    "survey.convert.dialog.title": "Convert Standard survey into Continuous",
    "survey.create-new-survey": "Create a new survey",
    "survey.custom-survey": "Custom Survey",
    "survey.delete": "Delete",
    "survey.delete2": "Delete survey",
    "survey.descPlaceholder": "Input question description here",
    "survey.duplicate": "Duplicate",
    "survey.edit": "Edit",
    "survey.edit2": "Edit survey",
    "survey.emails.off": "This survey is configured to NOT send email invitations and reminders",
    "survey.emptyEmailContent": "Please input email content for all languages",
    "survey.emptyEmailSubject": "Please input email subject for all languages",
    "survey.emptyExpiryTime": "Please select expiry time",
    "survey.emptySendTime": "Please select send time",
    "survey.emptyTimezone": "Please select timezone",
    "survey.error.manageNotAllowed": "You don't have permission to manage this survey.",
    "survey.filterByCategory": "Factor",
    "survey.list.no.active.triggers": "There are no active triggers configured. \nFor automation to work, at least one active trigger is required.",
    "survey.list.trigger.type.disabled": "Automation is deactivated. The system will not be automatically adding new survey candidates to this survey.",
    "survey.messaging.error.disableInProgress": "You can't turn off this channel while the survey is in progress. To pause all messaging on this channel, go to Company Settings → Integrations.",
    "survey.messaging.error.languageNotConfigured ": "One or more of the selected languages isn't set up for this survey.",
    "survey.messaging.error.saveFailed": "We couldn't save your messaging channel settings. Please try again.",
    "survey.messaging.error.smsAttributeNotPhone": "The selected attribute isn't a phone number attribute.",
    "survey.messaging.error.smsAttributeRequired": "Select a phone number attribute before turning on SMS.",
    "survey.messaging.error.smsAttributeWrongCompany": "The selected phone number attribute doesn't belong to this survey's company.",
    "survey.messaging.error.textRequired": "Add message text in at least one language before turning on this channel.",
    "survey.messaging.error.variationRequired": "Select a message variation before turning on this channel.",
    "survey.migrate.description.first": "This action takes your survey data file and populates this survey with those responses.",
    "survey.migrate.description.second": "Please make sure to first recreate all the questions from the original survey, and you can use survey migration template file for proper formatting.",
    "survey.migrate.error.commentsWithoutAnswer": "Questions has comment but no answer",
    "survey.migrate.error.duplicatedQuestions": "Duplicated questions",
    "survey.migrate.error.employeesWithWrongCompletedSurvey": "Employee not complete survey but have response data in the survey file",
    "survey.migrate.error.invalidEmployeeIds": "Employee Ids not exist",
    "survey.migrate.error.invalidRatingAnswers": "Scale questions with invalid rating answer",
    "survey.migrate.error.missingInvitationTimes": "Employees with no invitation time",
    "survey.migrate.error.missingMultipleChoiceOptions": "Options not exist in survey (multi-choice) question",
    "survey.migrate.error.missingSubmissionDates": "Employees who answered a question but have no submission date",
    "survey.migrate.error.noCompletedSurveyColumn": "Missing 'Completed Survey' column",
    "survey.migrate.error.noEmployeeIdColumn": "Missing 'Employee Id' column",
    "survey.migrate.error.noInvitationTimeColumn": "Missing 'Invitation Time' column",
    "survey.migrate.error.noSubmissionDateColumn": "Missing 'Submission Date' column",
    "survey.migrate.error.nonExistingQuestions": "Questions not exist in this survey",
    "survey.migrate.error.rejoinedEmployeeIds": "Employee rejoined same survey",
    "survey.migrate.error.unsupportedCompletedSurvey": "Incorrect 'Completed Survey' title format",
    "survey.migrate.error.unsupportedEmployeeId": "Incorrect 'Employee Id' title format",
    "survey.migrate.error.unsupportedTitles": "Unknown titles compared with company attributes",
    "survey.migrate.message.scheduled": "The system will work on migrating survey responses. You may close this window and track progress in the “Migrating” tab for progress and errors. Once the migration is successful you’ll be able to find the survey in the “Completed” tab.",
    "survey.migrate.select-file": "Select a file (.xlsx or .xls)",
    "survey.migrate.template": "Generate Template",
    "survey.nochanges": "Please note that you cannot make changes to the questions after the survey is sent out",
    "survey.optionPlaceholder": "Input option title here",
    "survey.preview": "Preview survey",
    "survey.recipients.changed": "You have unsaved changes to the participant list. Make sure to save them before you leave this screen.",
    "survey.recipients.save.button": "Save changes to participants",
    "survey.reminder": "Customize your Reminder message",
    "survey.reminder.button.create": "Schedule reminder",
    "survey.reminder.button.edit": "Save changes",
    "survey.reminder.button.view": "Schedule reminder",
    "survey.reminder.confirm.description.delete": "Are you sure you want to permanently delete this reminder and its content? You cannot undo this.",
    "survey.reminder.confirm.title.delete": "Delete scheduled reminder",
    "survey.reminder.create.success": "Reminder successfully created.",
    "survey.reminder.delete.success": "Reminder successfully deleted.",
    "survey.reminder.scheduled-date-time": "Scheduled date and time",
    "survey.reminder.scheduled-date-time.error": "The time should be between {{minDateTime}} and {{maxDateTime}} on ({{gmt}}) {{timezone}}.",
    "survey.reminder.scheduled-date-time.error.min-only": "The time should be after {{minDateTime}} on ({{gmt}}) {{timezone}}.",
    "survey.reminder.status.ERROR": "Error",
    "survey.reminder.status.PROCESSING": "Processing",
    "survey.reminder.status.SCHEDULED": "Scheduled",
    "survey.reminder.status.SENDING": "Sending",
    "survey.reminder.status.SENT": "Sent",
    "survey.reminder.timezone-desc": "All times are in ({{gmt}}) {{timezone}}",
    "survey.reminder.title.create": "Schedule a new reminder",
    "survey.reminder.title.edit": "Edit reminder",
    "survey.reminder.title.view": "View reminder",
    "survey.reminder.update.success": "Reminder successfully updated.",
    "survey.resend.employee.emails": "Resend the survey invite to the following emails?",
    "survey.responserates": "Response Rates",
    "survey.responses": "Responses",
    "survey.results": "Results",
    "survey.schedule.email.choose-language-to-edit": "Choose language to edit",
    "survey.schedule.email.from-email": "Sender email address",
    "survey.schedule.email.subject": "Email subject",
    "survey.schedule.frequency.custom": "Custom number of days",
    "survey.schedule.frequency.custom-label": "Days",
    "survey.schedule.frequency.errors.out-of-range": "Must be a number between 1 and 99",
    "survey.schedule.frequency.errors.required": "Number of days is required",
    "survey.schedule.frequency.every-x-days": "Every {{count}} days",
    "survey.schedule.frequency.info": "Reminders will be automatically sent out based on when a participant was invited. They will stop after participant completes survey or their access to survey expires.",
    "survey.schedule.from.max.length": "Maximum length of 255 characters",
    "survey.schedule.messaging.channel.email": "Email",
    "survey.schedule.messaging.channel.slack": "Slack",
    "survey.schedule.messaging.channel.sms": "SMS",
    "survey.schedule.messaging.channel.teams": "Teams",
    "survey.schedule.messaging.content-label.slack": "Slack message content",
    "survey.schedule.messaging.content-label.sms": "Text message content",
    "survey.schedule.messaging.content-placeholder": "Select a message",
    "survey.schedule.messaging.enable-label.slack": "Enable sending of invitations to participants via Slack",
    "survey.schedule.messaging.enable-label.sms": "Enable sending of invitations to participants via phone number (SMS texting)",
    "survey.schedule.messaging.enable-label.teams": "Enable sending of invitations to participants via Microsoft Teams",
    "survey.schedule.messaging.invitation-card-title": "Survey invitation",
    "survey.schedule.messaging.not-connected": "{{channel}} is enabled for your organization but isn’t connected yet. Invitations won’t be delivered until an admin connects {{channel}} in Company Settings → Integrations.",
    "survey.schedule.messaging.not-enabled": "Your organization does not have this functionality enabled. Please reach out to WorkTango Customer Service to discuss adding the {{channel}} module to your configuration.",
    "survey.schedule.messaging.sms.attribute-helper": "Employees without a cell phone number OR those on do-not-contact list will not receive this invitation",
    "survey.schedule.messaging.sms.attribute-label": "Attribute containing recipient cell phone number",
    "survey.schedule.messaging.sms.attribute-placeholder": "Select an attribute",
    "survey.schedule.messaging.sms.tcpa-warning": "The selected field must contain phone numbers that employees provided directly (e.g., entered themselves during onboarding or profile setup). Sending SMS to employer-assigned or IT-sourced numbers without employee consent may violate TCPA regulations and carrier requirements. By proceeding, you confirm these numbers were employee-provided.",
    "survey.schedule.messaging.tabs-aria-label": "Survey delivery channels",
    "survey.schedule.messaging.variation": "Variation {{number}}",
    "survey.schedule.remarks.survey-expiry": "Participants without submitted answers will remain in the survey, but will not be able to participate",
    "survey.schedule.reminder-content.label": "Reminder email content",
    "survey.schedule.reminder-frequency.label": "Reminder frequency",
    "survey.schedule.reminder-subject.label": "Reminder email subject",
    "survey.schedule.reminder-time.label": "Time of day to send the reminder",
    "survey.schedule.switch.survey_reminders": "Enable automatic reminders",
    "survey.schedule.switch.survey_reminders_callout": "In addition to automatic, Scheduled Reminders can be scheduled with custom wording from the Surveys page for surveys that have a status of \"Scheduled\" or \"In Progress\".",
    "survey.schedule.title": "Survey Schedule",
    "survey.schedule.title.continuous-survey": "Continuous survey settings",
    "survey.schedule.title.invitation": "Configure invitations and reminders",
    "survey.schedule.title.survey-expiry": "Survey link expiry date",
    "survey.schedule.title.survey_reminders": "Survey reminders",
    "survey.selectMore": "Select more surveys",
    "survey.selection": "Select surveys to add to current view",
    "survey.send.test.success": "A test email was sent to you. Please check your inbox!",
    "survey.sending.estimate": "An email will be sent to {{ total }} employees over the next {{ minutes }} minutes",
    "survey.set.survey.completed": "Move survey to Completed",
    "survey.set.survey.in.progress": "Move survey to In Progress",
    "survey.share.bypass-link": "Direct survey link to bypass the passcode",
    "survey.share.bypass-qr-code": "Direct survey QR code to bypass the passcode",
    "survey.share.copied": "Copied to your clipboard.",
    "survey.share.copy-bypass-link": "Copy direct link",
    "survey.share.copy-failed": "We couldn't copy that. Select it on the page and copy it instead.",
    "survey.share.copy-link": "Copy link",
    "survey.share.copy-passcode": "Copy passcode",
    "survey.share.device-count-one-device_other": "{{count}} responses from 1 device",
    "survey.share.device-count_one": "{{count}} response from {{deviceCount}} device",
    "survey.share.device-count_other": "{{count}} responses from {{deviceCount}} devices",
    "survey.share.download-bypass-qr-code": "Download direct QR code",
    "survey.share.download-qr-code": "Download QR code",
    "survey.share.link": "Survey link",
    "survey.share.passcode": "Passcode",
    "survey.share.passcode-failed": "We couldn't update the passcode. Try again.",
    "survey.share.passcode-hint": "Choose a word that can be pronounced easily, and avoid easily mistaken characters like zeros and the capital O",
    "survey.share.passcode-invalid": "A passcode can be up to 32 letters and numbers, and cannot contain I, L, O, 0 or 1.",
    "survey.share.passcode-saved": "Passcode updated.",
    "survey.share.passcode-toggle": "Protect the link with a passcode",
    "survey.share.qr-code": "Survey QR code",
    "survey.share.title": "Survey settings",
    "survey.stage.1": "Created & Scheduled",
    "survey.stage.2": "Completed & In Progress",
    "survey.stage.all": "All Statuses",
    "survey.status": "Status",
    "survey.status0": "Created",
    "survey.status1": "Scheduled",
    "survey.status2": "In Progress",
    "survey.status3": "Completed",
    "survey.status4": "Sending",
    "survey.status5": "Processing",
    "survey.status6": "Migrated",
    "survey.status7": "Failed migration",
    "survey.stop": "Cancel",
    "survey.tab.migrating": "Migrating",
    "survey.title.report-for": "Report for",
    "survey.titlePlaceholder": "Input question title here",
    "survey.trend": "Trend",
    "survey.type.disabled": "Disabled",
    "survey.view": "Preview",
    "surveyEdit.addLogic": "Add Logic",
    "surveyEdit.admin.unlockButton": "Edit Question",
    "surveyEdit.admin.unlockDesc": "You are about to edit a question that has been either been already answered in this survey or in another survey.\n\nEditing such a question may invalidate all previous responses. Editing this question will also affect the question in all the surveys it has been asked.\n\nAre you sure you want to edit this question?",
    "surveyEdit.admin.unlockTitle": "Please proceed with caution!",
    "surveyEdit.conditional": "Conditional",
    "surveyEdit.conditional.attribute": "This question is conditionally shown to respondents matching the following attribute(s): {{attributes}}",
    "surveyEdit.conditional.logic": "This question is conditionally shown based on certain Logic conditions",
    "surveyEdit.conditional.logicAndAttribute": "This question was conditionally shown based on certain Logic conditions, and respondents matching the following attribute(s): {{attributes}}",
    "surveyEdit.deleteLogic": "Delete Logic",
    "surveyEdit.deleteLogicConfirm": "Are you sure you want to delete this Logic block?",
    "surveyEdit.logic.addCondition": "Add Condition",
    "surveyEdit.logic.affectedQuestion": "Question to show",
    "surveyEdit.logic.broken": "This logic block refers to a question that no longer exists in this survey. Contact support if you need help, or delete it below.",
    "surveyEdit.logic.cancel": "Cancel",
    "surveyEdit.logic.conditionDesc": "Otherwise, hide Question {{order}}",
    "surveyEdit.logic.conditionDescMsg": "Otherwise, hide \"{{message}}\"",
    "surveyEdit.logic.deleteCondition": "Delete this condition",
    "surveyEdit.logic.disableAdd": "Need to add more logic conditions? Use the existing logic blocks above to add more conditions",
    "surveyEdit.logic.display": "Display",
    "surveyEdit.logic.if": "If",
    "surveyEdit.logic.incomplete": "Please complete or remove the incomplete conditions above",
    "surveyEdit.logic.or": "or",
    "surveyEdit.logic.question": "question",
    "surveyEdit.logic.response": "response",
    "surveyEdit.logic.save": "Save Logic",
    "surveyEdit.logic.selectAnswer": "Select an answer",
    "surveyEdit.logic.selectQuestion": "Select a question",
    "surveyEdit.logic.selectTitle": "For Question",
    "surveyEdit.logicEditor": "Logic Editor",
    "surveyEdit.logicEditorDesc": "Use the Logic Editor to decide which questions should show to your respondents based on previous answers. Questions are then hidden by default to all respondents until at least one of their conditions is met.",
    "surveyEdit.logicEditorEmpty": "You have no questions with Logic",
    "surveyEdit.message.placeholder": "Write your message here...",
    "surveyEdit.preventDeleting.desc": "This question has a logic condition attached to it. You’ll need to delete the logic condition first in the Logic Editor before you can delete this question.",
    "surveyEdit.preventDeleting.title": "This question cannot be deleted",
    "surveyEdit.preventOrdering.desc": "Changing your answer to this question will require you to re-answer all the following questions, as some questions might be visible or hidden based on your new answer.",
    "surveyEdit.preventOrdering.goTo": "Close and go to logic editor",
    "surveyEdit.preventOrdering.title": "This question cannot be re-ordered to this position",
    "surveyEdit.question.selectType": "Choose your question type",
    "surveyEdit.questionEditor": "Question Editor",
    "surveyEdit.updateLogic": "Edit Logic",
    "surveyEdit.yesNoQuestion.no": "No",
    "surveyEdit.yesNoQuestion.yes": "Yes",
    "surveyMigration.button": "Validate Survey Migration",
    "surveyMigration.closeButton": "Close",
    "surveyMigration.dialog.title": "Validate survey migration file",
    "surveyMigration.error.commentsWithoutAnswer": "Comments without answer:",
    "surveyMigration.error.duplicatedQuestions": "Duplicated questions:",
    "surveyMigration.error.missingMultipleChoiceOptions.description": "If the options are valid, check if they are using the correct separator/delimiter. They should be separated by <strong>|||</strong>.",
    "surveyMigration.error.missingMultipleChoiceOptions.label": "Missing multiple choice options:",
    "surveyMigration.error.missingMultipleChoiceOptions.options": "Options missing",
    "surveyMigration.error.missingRequiredFile": "The file doesn't have the required field {{field}}.",
    "surveyMigration.error.misspelledRequiredField": "The file has <strong>{{misspelledField}}</strong> instead of <strong>{{requiredField}}</strong>.",
    "surveyMigration.error.nonExistingQuestions": "These questions don't exist on the survey:",
    "surveyMigration.error.requiredFields.label": "Required field errors:",
    "surveyMigration.error.supportedFile.description": "We only support \".xlsx\" files at the moment.",
    "surveyMigration.error.supportedFile.label": "The file is not supported:",
    "surveyMigration.error.unsupportedTitles.description": "We only support <strong>Employee Id</strong>, <strong>Completed Survey</strong>, and titles that start with <strong>answer:::</strong> or <strong>comment:::</strong>.",
    "surveyMigration.error.unsupportedTitles.label": "Unsupported titles/headers:",
    "surveyMigration.successAlert.description": "Keep in mind that the can still contain undetected errors.",
    "surveyMigration.successAlert.title": "The file passed on our tests!",
    "surveyMigration.upload.label": "Select your file (we only support .xlsx)",
    "surveyMigration.validatingFile": "Validating file:",
    "surveyTemplates": "Survey Templates",
    "surveyTemplates.description": "These templates are accessible from and shared by all companies. Please keep new templates inactive until they are ready to be shared universally, and exercise caution when updating active templates, because they affect every customer.",
    "surveyType": "Survey Type",
    "surveyType.enName": "Survey Type Name(En)",
    "surveyType.exit": "Exit",
    "surveyType.factor.used": "This factor can't be deleted since it has been used by survey questions",
    "surveyType.frName": "Survey Type Name(Fr)",
    "surveyType.name": "Survey Type Name",
    "surveyType.onboarding": "Onboarding",
    "surveyTypes": "Survey Types",
    "surveyTypes.key": "Key",
    "surveyTypes.threshold": "Anonymity Threshold",
    "surveyTypesAndFactors": "Survey Types & Factors",
    "surveys": "Surveys",
    "surveys.addMoreSurveys": "Add more surveys",
    "surveys.cloneDialog.error": "A survey with this name already exists. Please enter a unique name.",
    "surveys.create.employees": "Employee List",
    "surveys.create.filter": "Search  Employee and Recipient List",
    "sv-se": "Swedish",
    "swal.confirm.delete": "Are you sure you want to delete this?",
    "swal.error.notfound": "Sorry, we don't recognize this username and password combination. Please try again.",
    "swal.info.launched": "Awesome! Your survey has now been scheduled!",
    "swal.message.surveySaved": "Your save was successful. Woohoo!",
    "swal.reminders.already.scheduled": "Reminders for this survey have already been scheduled and will be sent out shortly.",
    "swal.reminders.send": "Reminders will be sent to all employees that have not yet filled out the survey. This will take approximately {{timeToSendMin}} minutes.",
    "swal.saved": "Saved!",
    "swal.survey.emails.no.language.error": "You must enabled at least one language for your email",
    "switch.current": "Current Company",
    "system.field.deleted": "[Attribute Deleted]",
    "system.field.disabled": "Deactivated",
    "system.field.email": "Email",
    "system.field.enabled": "Active",
    "system.field.firstname": "First Name",
    "system.field.language": "Language",
    "system.field.lastname": "Last Name",
    "system.field.manageremail": "People Leader's Email",
    "system.field.permissions": "Permissions",
    "system.field.reportingMax": "Maximum 10 reporting attributes allowed",
    "system.field.startdate": "Start Date",
    "table.nodata": "Nothing here at the moment... let's change that!",
    "table.stop": "Stop",
    "templates.clone": "Clone template",
    "templates.cloneDialog.description": "Please choose a unique name for the new template.",
    "templates.cloneDialog.error": "A template with this name already exists. Please enter a unique name.",
    "templates.cloneDialog.title": "Clone template \"{{name}}\"?",
    "templates.create": "Create new template",
    "templates.deactivate": "Deactivate template",
    "templates.delete": "Delete template",
    "templates.deleteDialog.button.cancel": "Cancel",
    "templates.deleteDialog.button.delete": "Yes, Delete",
    "templates.deleteDialog.description": "Deleting a template will permanently remove it from the platform, and no customer will be able to see or use it in the future.",
    "templates.deleteDialog.description2": "This action cannot be undone.",
    "templates.deleteDialog.description3": "Are you sure you want to delete this template?",
    "templates.deleteDialog.title": "Delete template \"{{name}}\"?",
    "templates.edit": "Edit template",
    "templates.lastUpdated": "Last updated",
    "templates.name": "Template name",
    "templates.status": "Template status",
    "templates.survey-type.no.compatible": "There are no survey types configured that are compatible with this template.",
    "templates.survey-type.no.compatible-plural": "There are no survey types configured that are compatible with the available templates.",
    "templates.survey-type.no.permissions": "You do not have permissions to create a survey of this type.",
    "templates.surveyStyles": "Survey Styles",
    "templates.type": "Survey type",
    "templates.zeroState": "There are no templates configured.",
    "term.accept": "I agree to the",
    "term.title": "Terms of Use",
    "terms.of.use": "Terms of use",
    "th-th": "Thai",
    "thanks.for.rating": "Thanks for rating!",
    "themes.button.generate": "Identify themes...",
    "themes.button.regenerate": "Re-generate themes...",
    "themes.description.generate": "Ask AI to organize responses into themes?",
    "themes.description.generate.loading": "AI is generating key themes...",
    "themes.description.regenerate": "Ask AI to re-run theme analysis?",
    "themes.description.regenerate.loading": "AI is re-generating key themes...",
    "themes.toast.error.generate": "Themes could not be generated. Please try again.",
    "themes.toast.error.regenerate": "Themes could not be re-generated. The previous themes were kept. Please try again.",
    "themes.toast.success.generate": "Themes generated successfully.",
    "themes.toast.success.regenerate": "Themes re-generated successfully.",
    "tiho.test": "This is my text for the modal.",
    "title.lockedOut": "Your account has been locked",
    "tooltip.new": "New",
    "tooltip.upload": "Upload",
    "top.attributes": "Top five attributes",
    "tr-tr": "Turkish",
    "trend.annual": "Annual",
    "trend.group": "Group by",
    "trend.month": "Month",
    "trend.no.survey": "No matched survey",
    "trend.quarter": "Quarter",
    "trend.search.factor": "Search by Factor",
    "trend.search.question": "Search by Question",
    "trend.survey": "Survey",
    "trending.heatmap.anonymizedAttributes": "The attributes below are anonymized, therefore excluded from the heatmap.",
    "trending.heatmap.uniqueAttributes": "The attributes below are only present in one of the two surveys, and is therefore excluded from the heatmap.",
    "trends.addSurvey": "Add Survey",
    "trends.button.change-timeframes": "Change Timeframes",
    "trends.button.select-surveys": "Select standard surveys to trend...",
    "trends.button.select-timeframes": "Trend continuous survey’s timeframes",
    "trends.empty": "Compare to up to 10 surveys to determine how your factors and questions are trending in your organization.",
    "trends.errors.missing-date": "You need to enter both start and end date on custom timeframes",
    "trends.selectSurveyType": "Select a survey type",
    "trends.subtitle.time-frames": "Trending between {{count}} selected timeframes between",
    "trends.suppressed.label": "Not enough responses",
    "trends.timeframes-dialog.add-timeframe": "Add a timeframe",
    "trends.timeframes-dialog.submit-button": "Show trends for these timeframes",
    "trends.timeframes-dialog.title": "Choose two or more timeframes to trend",
    "trends.title": "Trends",
    "trends.title.trends-for": "Trends for",
    "trends.view": "View",
    "trigger.status.paused": "Paused",
    "triggers.type.exitDate": "Exit Date",
    "triggers.type.startDate": "Start Date",
    "update.snapshots": "Update Snapshots",
    "user": "User",
    "user.activation.codeNotFound": "Activation Code Not Found",
    "user.activation.description": "You've been invited by {{ companyName }} join WorkTango with your account: {{ userEmail }}",
    "user.activation.loginOrGetInvited": "If you have already activated your account, please login here. If you have not yet activated your account, please contact your account administrator to receive an invitation.",
    "user.activation.success": "You can now access WorkTango with your account. Click OK to log into WorkTango.",
    "user.activation.title": "Woohoo! Your account has been successfully activated!",
    "user.invite.message": "you've received an invitation by %inviter% (%company%) to use WorkTango, a platform that helps give employees a voice and offer real-time feedback for our organization. Please click below to complete your registration.",
    "user.invite.subject": "You're invited to WorkTango",
    "user.login.email": "Email",
    "user.login.forgot": "Forgot password?",
    "user.login.privacy.notice": "Privacy notice",
    "user.login.privacy.policy": "Privacy policy",
    "user.login.terms.of.use": "Terms of use",
    "user.not.found": "User was not found",
    "user.password.reset.email": "Click below to reset your password.",
    "user.password.reset.subject": "Reset password",
    "user.remove.customAttributes": "Previously selected custom atributes will be removed, are you sure?",
    "user.reset.header": "Reset Password",
    "user.reset.password": "Enter New Password",
    "user.reset.password.confirmation": "Confirm password",
    "user.reset.passwordMatch": "Passwords do not match",
    "users.addButton": "Add Users",
    "users.column.customPermission": "Custom Permissions",
    "users.column.customPermissionDesc": "This user has customized permissions that only apply to them.",
    "users.invite.email.addresses": "Email Addresses",
    "users.invite.email.csv": "Invite multiple users by separating them with a \",\"",
    "users.invite.invited.by": "Invited by",
    "users.invite.loading.employees": "Loading employees...",
    "users.invite.name.from": "Name from which invitation email is sent",
    "users.invite.search.employees.and.emails": "Search employees or input custom address",
    "users.mainHeader": "Users & Permissions",
    "users.role.checkbox.cannot.select.kw.default.role": "If you wish to customize this person's permissions more granularly, please grant them \"SURVEY CUSTOM\" role in User Management.",
    "users.role.selectDesc": "Assign an existing role to the above user(s) or set up customized permissions for them.",
    "users.role.selectLabel": "Select a role or custom permissions",
    "users.role.selectTitle": "Role",
    "users.role.selectedNotice": "Below are the permissions for {{name}}. You can edit these permissions in the Roles section.",
    "users.role.selectedNoticeIntegrated": "Below are the permissions for {{name}}. You can change user's role in User Management area, or you can grant them a \"Custom\" role to unlock Surveys & Insights granular permissions.",
    "users.rolePermissionType": "Custom Permissions",
    "users_one": "{{count}} user",
    "users_other": "{{count}} users",
    "validating": "Validating...",
    "view.by": "View by",
    "view.communication.templates.for.suggestions": "View our communication templates for suggestions",
    "view.content": "View Content",
    "welcome": "You've been invited to the WorkTango Platform!",
    "wizard.next": "Next",
    "wizard.previous": "Previous",
    "worktango.admin.export": "Raw Export",
    "worktango.powered": "Powered by WorkTango",
    "yes_no_banana": "Ripening Banana",
    "yes_no_check_and_x": "Check and X",
    "yes_no_faces": "Faces",
    "yes_no_glasses_of_water": "Glasses of Water",
    "yes_no_ice_box": "Ice Cream Cone",
    "yes_no_lightbulb": "Lightbulb",
    "yes_no_mood_weather": "Mood Weather",
    "yes_no_pizza_box": "Pizza Box",
    "yes_no_red_rose": "Rose",
    "yes_no_snowman": "Snowman",
    "yes_no_thumbs": "Thumbs",
    "yes_no_toilet_paper": "Toilet Paper",
    "zh-cn": "Chinese (simplified)",
    "zh-tw": "Chinese (traditional)",
    "survey.language.ar-sa": "عربي",
    "survey.language.cs-cz": "Čeština",
    "survey.language.da-dk": "Dansk",
    "survey.language.de-de": "Deutsch",
    "survey.language.el-gr": "Ελληνικά",
    "survey.language.en-ca": "English (CA)",
    "survey.language.en-us": "English (US)",
    "survey.language.es-es": "Español",
    "survey.language.fi-fi": "Suomi",
    "survey.language.fr-ca": "Français (CA)",
    "survey.language.fr-fr": "Français (FR)",
    "survey.language.hi-in": "हिन्दी",
    "survey.language.hu-hu": "Magyar",
    "survey.language.id-id": "Indonesia",
    "survey.language.it-it": "Italiano",
    "survey.language.jp-jp": "日本語",
    "survey.language.ko-kr": "한국어",
    "survey.language.ms-my": "Bahasa Melayu",
    "survey.language.my-mm": "မြန်မာဘာသာ",
    "survey.language.nb-no": "Norsk Bokmål",
    "survey.language.nl-nl": "Nederlands",
    "survey.language.pl-pl": "Polski",
    "survey.language.pt-br": "Português (BR)",
    "survey.language.pt-pt": "Português (PT)",
    "survey.language.ru-ru": "Pусский",
    "survey.language.sq-al": "Shqip",
    "survey.language.sv-se": "Svenska",
    "survey.language.th-th": "แบบไทย",
    "survey.language.tr-tr": "Türkçe",
    "survey.language.zh-cn": "简化字",
    "survey.language.zh-tw": "繁體中文"
  }
}
